<template>
  <v-app id="alert-details-app" class="alertDetails">
    <v-overlay absolute :value="deleting || loading || saving">
      <v-progress-circular
          indeterminate
          color="var(--primary-btn-bg-color)"
          size="64"
      ></v-progress-circular>
    </v-overlay>
    <section>
      <v-container fluid id="alert-header" class="alert-header">
        <div class="vy-row">
          <v-col>
            <div class="vy-row title-breadcrumb-row"><span class="title-breadcrumb">Monitors<span class="title-breadcrumb-divider">/</span><a href="#monitoring/moi">Monitors</a><span class="title-breadcrumb-divider">/</span></span></div>
            <div class="vy-row title-text-row">
              <span
                  class="status-chip alert-state-container"
                  v-if="status"
              >
                <span><i :class="statusIcon" class="fa-fw ad-status-icon" aria-hidden="true"></i>{{status}}</span>
              </span>
              <v-text-field
                  v-if="isEditMode"
                  ref="titleTextField"
                  class="header-title"
                  single-line
                  dense
                  hide-details
                  full-width
                  @click="titleClick"
                  v-model="currentTitle"
              ></v-text-field>
              <span v-if="!isEditMode"
                    class="header-title title-row"
                    :title="currentTitle"
              ><span v-if="!currentTitle">&nbsp;</span>
                {{currentTitle}}
              </span>
            </div>
          </v-col>
          <v-col cols="auto" class="d-flex align-center action-toolbar">
            <div class="vy-row flex-nowrap">
              <v-col cols="auto">
                <div class="vy-row flex-nowrap">
                  <v-item-group class="v-btn-toggle">

                  <v-tooltip
                      color="var(--tooltip-background)"
                      nudge-bottom="-1"
                      bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          class="action-group-btn"
                          v-on="on"
                          :ripple="false"
                          outlined
                          v-on:click="enabled = !enabled; onEnable();">

                        <label align="left" class="legend-title legend-switch action-switch" v-on:click.stop="onStop($event)">
                          <input id="enabled" type="checkbox" v-model="enabled" v-on:change="onEnable" :aria-checked="enabled.toString()">
                          <span class="legend-slider"></span>
                        </label>
                        <label for="enabled" class="legend-title"></label>
                      </v-btn>
                    </template>
                    <span>{{enabled ? 'Disable' : "Enable"}}</span>
                  </v-tooltip>

                    <v-tooltip
                        color="var(--tooltip-background)"
                        nudge-bottom="-1"
                        bottom>
                      <template v-slot:activator="{ on }">

                        <v-btn
                            class="action-group-btn"
                            v-on="on"
                            :disabled="isEditMode || nonEditableInternalFilter"
                            :ripple="false"
                            outlined
                            @click="onEdit">
                          <v-icon size="18">far fa-pen</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit</span>
                    </v-tooltip>

                    <confirm v-if="isEditMode" ref="confirmDelete"></confirm>
                    <v-tooltip
                        color="var(--tooltip-background)"
                        nudge-bottom="-1"
                        bottom>
                      <template v-slot:activator="{ on }">

                        <v-btn
                            class="action-group-btn"
                            v-on="on"
                            :loading="deleting"
                            :disabled="isViewMode || isNew"
                            :ripple="false"
                            outlined
                            @click="onDelete">
                          <v-icon size="18">far fa-trash-alt</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete</span>
                    </v-tooltip>

                    <v-tooltip
                        color="var(--tooltip-background)"
                        nudge-bottom="-1"
                        bottom>
                      <template v-slot:activator="{ on }">

                        <v-btn
                            class="action-group-btn"
                            v-on="on"
                            :ripple="false"
                            outlined
                            @click="onCancel">
                          <v-icon size="18">far fa-times-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>{{isEditMode ? 'Cancel' : 'Close'}}</span>
                    </v-tooltip>


                    <v-tooltip
                        color="var(--tooltip-background)"
                        nudge-bottom="-1"
                        bottom>
                      <template v-slot:activator="{ on }">

                        <v-btn
                            class="action-group-btn save-btn"
                            color="var(--primary-btn-bg-color)"
                            v-on="on"
                            :disabled="isViewMode || !complete"
                            :ripple="false"
                            :outlined="isViewMode || !complete"
                            @click="onSave">
                          <v-icon size="18">far fa-check-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Save</span>
                    </v-tooltip>

                  </v-item-group>
                </div>
              </v-col>
            </div>
          </v-col>
        </div>
      </v-container>

      <section class="content alert-main-view">
        <div class="alertMainPanel content-min-height">
          <v-container fluid class="alert-layout pt-0 pb-3 px-5">
            <v-col class="pa-0">
              <div class="vy-row table-row flex-nowrap ma-0" v-if="isViewMode && currentGroupByDisplay.length > 0">
                <section class="table-cell-1 group-by-statuses">
                    <v-container fluid id="groupByStatuses"><div class="vy-row">
                      <v-col>
                        <div class="vy-row flex-nowrap">
                          <v-col cols="12">
                            <div class="vy-row">
                              <alert-group-status
                                  ref="alertGroupStatus"
                                  :alert-id="currentId"
                                  :group-data="groupStatuses"
                                  :groupBy="currentGroupBy"
                                  :groupByDisplay="currentGroupByDisplay"
                              />
                            </div>
                          </v-col>
                        </div>
                      </v-col>
                    </div>
                    </v-container>
                    <v-divider></v-divider>
                  </section>
              </div>
              <div class="vy-row table-row flex-nowrap ma-0 table-header-row">
                <svg v-if="typeSet && isEditMode" class="table-cell-0 edit-instructions-svg" width="24" height="24">
                  <circle class="edit-instructions-circle" cx="12" cy="12" r="12"></circle>
                  <text class="edit-instructions-text" x="50%" y="50%" dy="0.33em">1</text>
                </svg>
                <v-container fluid class="table-cell-1"><div class="vy-row">
                    <v-col cols=auto>
                      <div class="vy-row">
                        <v-col>
                          <div class="vy-row">
                            <span v-if="typeSet && isEditMode && !isEvent" class="instructions-section-header-text">Select the metric</span>
                            <span v-if="typeSet && isEditMode && isEvent" class="instructions-section-header-text">Set filter conditions for</span>
                            <span v-if="typeSet && isViewMode && !isEvent">
                              <i class="far fa-chart-line section-header-icon"></i>
                              <span class="instructions-section-header-text">Metric</span>
                              <span class="instructions-section-subheader-text">
                                <span> / </span>
                                <span
                                  v-if="isViewMode && selectedCategoryMetadata">
                                  {{ selectedCategoryMetadata.name }} /
                                </span>
                                <span v-if="isViewMode && selectedMetricMetadata">
                                  <i v-if="selectedMetricMetadata.cdr"
                                     class="far fa-hourglass-half fa-fw cdr-icon"
                                     aria-hidden="true"></i>
                                  <i v-if="!selectedMetricMetadata.cdr"
                                     class="fas fa-water fa-fw cdr-icon" aria-hidden="true"></i>
                                  <span>
                                    {{ selectedMetricMetadata.name }}
                                  </span>
                                </span>
                                <span v-if="currentGroupByDisplay.length > 0">&nbsp;/ <span class="group-info">Group By 
                                    <span>
                                      {{currentGroupByDisplay.join(', ')}}
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                            <span v-if="typeSet && isViewMode && isEvent">
                              <i class="far fa-rectangle-list section-header-icon"></i>
                              <span class="instructions-section-header-text">Events</span>
                              <span class="instructions-section-subheader-text">
                                <span> / </span>
                                <span class="group-info">Group By 
                                    <span>
                                      {{currentGroupByDisplay.join(', ')}}
                                    </span>
                                  </span>
                              </span>
                            </span>
                          </div>
                        </v-col>
                      </div>
                    </v-col>
                  </div></v-container>
              </div>
              <div class="vy-row table-row flex-nowrap ma-0" v-if="typeSet && !isEvent">
                <svg v-if="typeSet && isEditMode" class="table-cell-0 edit-instructions-svg" width="24" height="24">
                </svg>
                <section class="table-cell-1 metricSelection">
                    <v-container fluid id="metricSelection"><div class="vy-row">
                      <v-col class="col metricSelectionEdit"
                          v-if="isEditMode"
                          cols="12" lg="6">
                        <div class="vy-row">
                          <v-col>
                            <div class="vy-row">
                              <span class="field-label">Category</span>
                            </div>
                            <div class="vy-row">
                              <v-select
                                  :items="categories"
                                  name="Category"
                                  dense
                                  outlined
                                  single-line
                                  hide-details
                                  :menu-props="{ maxHeight:'75%' }"
                                  append-icon="fal fa-chevron-down"
                                  class="select-field"
                                  placeholder="Select"
                                  v-model="currentCategory"
                                  :rules="[rules.required]"
                                  @change="handleCategoryChange"
                              ></v-select>
                            </div>
                          </v-col>
                          <v-col>
                            <div class="vy-row">
                              <span class="field-label">Metric</span>
                            </div>
                            <div class="vy-row">
                              <v-select
                                  :disabled="!currentCategory"
                                  name="Metric"
                                  :items="metrics"
                                  dense
                                  outlined
                                  single-line
                                  hide-details
                                  :menu-props="{ eager: true, maxHeight:'75%'}"
                                  append-icon="fal fa-chevron-down"
                                  class="select-field"
                                  placeholder="Select"
                                  v-model="currentMetric"
                                  :rules="[rules.required]"
                                  @change="handleMetricChange"
                              >
                                <template v-slot:selection="{ item }">
                                  <v-container fluid class="v-select__selection v-select__selection--comma selection-container">
                                    <div class="vy-row flex-nowrap">
                                      <v-col cols="auto">
                                        <i v-if="item.extra.cdr" class="far fa-hourglass-half fa-fw cdr-icon" :class="item.extra.deprecated?'deprecated':''" aria-hidden="true"></i>
                                        <i v-if="!item.extra.cdr" class="fas fa-water fa-fw cdr-icon" :class="item.extra.deprecated?'deprecated':''" aria-hidden="true"></i>
                                        <span class="submetric">{{ item.text || item }}</span>
                                      </v-col>
                                      <v-col>
                                        <div class="vy-row flex-nowrap justify-end">
                                          <v-col
                                              class="system-icon-col"
                                              cols="auto"
                                              v-if="item.extra.models"
                                              v-for="(model, index) in item.extra.models"
                                              :key="model.id">
                                            <v-tooltip bottom>
                                              <template v-slot:activator="{ on }">
                                                <v-avatar
                                                    rounded
                                                    size="18"
                                                    v-on="on"
                                                >
                                                  <img :src="getSystemImageUrl(model.id)" />
                                                </v-avatar>
                                              </template>
                                              {{ model.name }}
                                            </v-tooltip>
                                          </v-col>
                                        </div>
                                      </v-col>
                                    </div>
                                  </v-container>
                                </template>
                                <template v-slot:item="{ item }">
                                  <v-container fluid class="item-container">
                                    <div class="vy-row flex-nowrap">
                                      <v-col cols="auto">
                                        <i v-if="item.extra.cdr" class="far fa-hourglass-half fa-fw cdr-icon" :class="item.extra.deprecated?'deprecated':''" aria-hidden="true"></i>
                                        <i v-if="!item.extra.cdr" class="fas fa-water fa-fw cdr-icon" :class="item.extra.deprecated?'deprecated':''" aria-hidden="true"></i>
                                        <span class="submetric">{{ item.text || item }}</span>
                                      </v-col>
                                      <v-col>
                                        <div class="vy-row flex-nowrap justify-end">
                                          <v-col
                                              class="system-icon-col"
                                              cols="auto"
                                              v-if="item.extra.models"
                                              v-for="(model, index) in item.extra.models"
                                              :key="model.id">
                                            <v-tooltip bottom>
                                              <template v-slot:activator="{ on }">
                                                <v-avatar
                                                    rounded
                                                    size="18"
                                                    v-on="on"
                                                >
                                                  <img :src="getSystemImageUrl(model.id)" />
                                                </v-avatar>
                                              </template>
                                              {{ model.name }}
                                            </v-tooltip>
                                          </v-col>
                                        </div>
                                      </v-col>
                                    </div>
                                  </v-container>
                                </template>
                              </v-select>
                            </div>
                          </v-col>
                        </div>
                        <div class="vy-row second-row" v-if="currentMetric">
                          <v-col>
                            <div class="vy-row field-label">
                              <span>Group By</span>
                              <v-tooltip
                                  color="var(--tooltip-background)"
                                  nudge-bottom="-3"
                                  min-width="333"
                                  bottom>
                                <template v-slot:activator="{ on }">
                                  <span v-on="on" class="info-btn ml-1 mr-1"><i class="far fa-info-circle"></i></span>
                                </template>
  
                                <v-col class="pa-0" >
                                  <div class="groupby-tt-header pt-0">Nothing</div>
                                  <div class="groupby-tt-body">Single notification when the alert conditions are met.</div>
                                  <div class="groupby-tt-header pt-2">Simple</div>
                                  <div class="groupby-tt-body">Separate notification for each {{groupBySimpleTooltip}} when the alert trigger conditions are met.</div>
                                  <div class="groupby-tt-header pt-2">Advanced</div>
                                  <div class="groupby-tt-body">Separate notification for each group when the alert trigger conditions are met.</div>
                                </v-col>
                                
                              </v-tooltip>
                            </div>
                            <div class="vy-row">
                              <v-select
                                  :items="groupBys"
                                  name="Group By"
                                  dense
                                  outlined
                                  multiple
                                  single-line
                                  hide-details
                                  :menu-props="{ maxHeight:'330px', contentClass: 'group-by-menu-content' }"
                                  append-icon="fal fa-chevron-down"
                                  class="select-field"
                                  placeholder="Nothing"
                                  v-model="currentGroupBy"
                                  @change="handleGroupByChange"
                              ></v-select>
                            </div>
                          </v-col>
                          <v-col>
  
                          </v-col>
                        </div>
                      </v-col>
                      <v-col cols="12" :lg="isViewMode ? 12 : 6">
                          <alert-chart
                              ref="alertChart"
                              :category="currentCategory"
                              :categoryDisplay="categoryDisplay"
                              :metric="currentMetric"
                              :metricDisplay="metricDisplay"
                              :filterBy="currentFilterDescription"
                              :filter="currentFilterRSQL"
                              :groupBy="currentGroupBy"
                              :groupByDisplay="currentGroupByDisplay"
                              :groupByColors="currentGroupByColors"
                              :duration="duration"
                              :window="window"
                              :operation="operation"
                              :critical="conditionsAndNotificationItems.critical.threshold"
                              :warn="conditionsAndNotificationItems.warn.threshold"
                              :info="conditionsAndNotificationItems.info.threshold"
                              :start="start"
                              :end="end"
                              :showThresholds="showThresholds"
                              :height="chartHeight"
                              :ts="ts"
                              :split-series="uniqueThreshold"
                              :is-view-mode="isViewMode"
                              alt="A chart showing the current data that the alert will be based on"
                          />
                      </v-col>
                    </div></v-container>
                    <v-divider></v-divider>
                  </section>
              </div>
              <div class="vy-row table-row flex-nowrap ma-0" v-if="typeSet && isEvent">
                <svg v-if="typeSet && isEditMode" class="table-cell-0 edit-instructions-svg" width="24" height="24">
                </svg>
                <section class="table-cell-1 eventSelection">
                  <v-container fluid id="eventSelection"><div class="vy-row">

                    <v-col class="col eventSelectionEdit"
                           v-if="isViewMode && currentFilterDescription"
                           cols="12">
<!--                      <div class="vy-row for-these-row"><span class="event-filter-title">Events</span></div>-->
                      <div class="vy-row for-these-row">{{ currentFilterDescription }}</div>
<!--                      <div class="vy-row" v-if="isViewMode && isEvent && currentEventSourceFilterDisplay"class="for-these-row">-->
<!--                        <span class="instructions-section-header-text">Endpoints</span>-->
<!--                      </div>-->
<!--                      <div class="vy-row" v-if="isViewMode && isEvent && currentEventSourceFilterDisplay"class="for-these-row">-->
<!--                        <span>{{ currentEventSourceFilterDisplay }}</span>-->
<!--                      </div>-->
                    </v-col>
                    <v-col class="col eventSelectionEdit"
                           v-if="isEditMode"
                           cols="12">
                      <div class="vy-row for-these-row"><span class="event-filter-title">Events</span></div>
                      <div class="vy-row for-these-row" v-if="eventFilterColumns && eventFilterColumns.length > 0">
                        <filter-expression
                            ref="event-filter"
                            :columns="eventFilterColumns"
                            dataset-name="events"
                            :filter-groups="currentEventsFilterModel ? currentEventsFilterModel.filterGroups : []"
                            :operator="currentEventsFilterModel ? currentEventsFilterModel.operator :'and'"
                            @filters-updated="onEventsFilterChange"
                            @operator-changed="onEventsFilterOperatorChange"
                        ></filter-expression>
                      </div>
                    </v-col>

                  </div></v-container>
                  <v-divider v-if="isEditMode"></v-divider>
                </section>
              </div>
              <div class="vy-row table-row flex-nowrap ma-0" v-if="typeSet && isEvent">
                <svg v-if="typeSet && isEditMode" class="table-cell-0 edit-instructions-svg" width="24" height="24">
                </svg>
                <section class="table-cell-1 eventSelection lower-1">
                  <v-container fluid id="eventSourceSelection"><div class="vy-row">

                    <v-col class="col eventSelectionEdit"
                           v-if="isEditMode"
                           cols="12">
                      <div class="vy-row for-these-row"><span class="event-filter-title">Endpoints</span></div>
                      <div class="vy-row for-these-row" v-if="eventSourceFilterColumns && eventSourceFilterColumns.length > 0">
                        <filter-expression
                            ref="event-source-filter"
                            :columns="eventSourceFilterColumns"
                            dataset-name="endpoints"
                            :filter-groups="currentEventSourceFilterModel ? currentEventSourceFilterModel.filterGroups : []"
                            :operator="currentEventSourceFilterModel ? currentEventSourceFilterModel.operator : 'and'"
                            @filters-updated="onEventSourceFilterChange"
                            @operator-changed="onEventSourceFilterOperatorChange"
                        ></filter-expression>
                      </div>
                    </v-col>

                  </div></v-container>
                  <v-divider></v-divider>
                </section>
              </div>
              <div class="vy-row table-row flex-nowrap ma-0 table-header-row" v-if="typeSet && isEditMode && !isEvent">
                <svg v-if="typeSet && isEditMode" class="table-cell-0 edit-instructions-svg" width="24" height="24">
                </svg>
                <v-container fluid class="table-cell-1"><div class="vy-row">
                    <v-col cols=auto>
                      <div class="vy-row">
                        <v-col>
                          <div class="vy-row instructions-section-header-row">
                            <span v-if="!currentMetric" class="instructions-section-header-text">Set filter conditions</span>
                            <span v-if="currentMetric" class="instructions-section-header-text">Set filter conditions for these {{datasetDisplayName}}</span>
                            <span v-if="currentMetric" class="instructions-section-header-text-hint">(optional)</span>
                          </div>
                        </v-col>
                      </div>
                    </v-col>
                  </div></v-container>
              </div>
              <div class="vy-row table-row flex-nowrap ma-0" v-if="typeSet && isEditMode && !isEvent">
                <svg v-if="typeSet && isEditMode" class="table-cell-0 edit-instructions-svg" width="24" height="24">
                </svg>
                <section class="table-cell-1 filterSelection">
                    <v-container fluid id="filterSelection"><div class="vy-row">
                      <v-col class="col metricSelectionEdit"
                             cols="12" lg="12">
                        <div class="vy-row" v-if="blockThresholdAndNotifications">
                          <v-card
                              outlined
                              width="100%"
                              class="preselection-message">
                            <v-card-subtitle>
                              You must select the Category and Metric first
                            </v-card-subtitle>
  
                          </v-card>
                        </div>
                        <div class="vy-row flex-nowrap" v-if="currentMetric">
                          <v-col>
                            <div class="vy-row before-devices-label"><span v-if="simpleQualityMode && internalUserOrScubaV1OptIn" class="field-label">Call Quality <i-v-tooltip ref="qualityTooltip" color="#7C868C" top content-class="above" interactive :opacity="1">
                                <template v-slot:activator="{ on }">
                                    <span class="info-btn"><i v-on="on" class="far fa-info-circle"></i></span>
                                </template>
                                <v-col
  
                                    class="pa-0 quality-tt" >
                                  <div class="quality-tt-header pt-0">GOOD<span class="ml-2 mr-2">FAIR</span>BAD</div>
                                  <div class="quality-tt-body">WXP Collaboration quality algorithm</div>
                                  <div class="quality-tt-header pt-2">UNKNOWN</div>
                                  <div class="quality-tt-body">Quality data unavailable</div>
                                  <div class="quality-tt-link pt-2"><a :href="brandingService.getSupportUrl('qualityImprovements')" target='_blank' title='Learn More'>Learn More</a></div>
                                </v-col>
                              </i-v-tooltip></span>
                            </div>
                          </v-col>
                        </div>
                        <div class="vy-row for-these-row"  v-if="currentMetric && filterColumns && filterColumns.length > 0" >
                          <quality-filters v-if="simpleQualityMode && internalUserOrScubaV1OptIn"
                                           :quality-filters="qualityFilters"
                                           @quality-filters="onQualityFiltersChanged"
                          />
  
                          <confirm ref="confirmClearDynamic"></confirm>
                          <filter-expression
                              ref="alert-filter"
                              :disabled="!currentCategory"
                              :columns="filterColumns"
                              :dataset-name="currentCategory"
                              :excluded-quick-picks="excludedQuickPicks"
                              :filter-groups="currentFilterModel.filterGroups"
                              :operator="currentFilterModel.operator"
                              @filters-updated="onFilterChange"
                              @operator-changed="onFilterOperatorChange"
                          ></filter-expression>
                        </div>
                      </v-col>
                    </div></v-container>
                    <v-divider></v-divider>
                  </section>
              </div>
              <div class="vy-row table-row flex-nowrap ma-0 table-header-row">
                <svg v-if="typeSet && isEditMode" class="table-cell-0 edit-instructions-svg" width="24" height="24">
                  <circle class="edit-instructions-circle" cx="12" cy="12" r="12"></circle>
                  <text class="edit-instructions-text" x="50%" y="50%" dy="0.33em">2</text>
                </svg>
                <v-container fluid class="table-cell-1"><div class="vy-row">
                    <v-col cols=auto>
                      <div class="vy-row">
                        <v-col>
                          <div class="vy-row instructions-section-header-row">
                            <span v-if="typeSet && isEditMode" class="instructions-section-header-text">Define status trigger(s) <span v-if="currentGroupBy.length > 0" class="group-info"> for each Group</span></span>
                            <span v-if="typeSet && isViewMode" class="instructions-section-header-text">Status Trigger<span v-if="triggers.length > 1">s</span> <span v-if="currentGroupBy.length > 0" class="group-info"> for each <span v-if="!isEvent">Group</span><span v-if="isEvent">Event</span></span></span>
                          </div>
                        </v-col>
                      </div>
                    </v-col>
                    </div></v-container>
              </div>
              <div class="vy-row table-row flex-nowrap ma-0">
                <svg v-if="typeSet && isEditMode" class="table-cell-0 edit-instructions-svg" width="24" height="24">
                </svg>
                <section class="table-cell-1 thresholdSelection">
                    <v-container fluid id="thresholdSelection"><div class="vy-row">
                      <v-col>
                        <div class="vy-row" v-if="typeSet && blockThresholdAndNotifications">
                          <v-card
                              outlined
                              width="100%"
                              class="preselection-message">
                            <v-card-subtitle>
                              You must select the Category and Metric first
                            </v-card-subtitle>
  
                          </v-card>
                        </div>
  
                        <div v-for="(trigger, index) in triggers"
                               v-if="typeSet && !blockThresholdAndNotifications"
                               :key="trigger.id"
                               class="vy-row trigger-sentence-row"
                        >
                          <v-select
                              :items="statuses"
                              :disabled="isViewMode"
                              dense
                              outlined
                              single-line
                              hide-details
                              :menu-props="{ maxHeight:'75%' }"
                              :append-icon="isEditMode ? 'fal fa-chevron-down' : ''"
                              class="select-field flex-grow-0 flex-shrink-0 select-status"
                              :class="isEditMode?'mr-2':''"
                              placeholder="Select"
                              v-model="trigger.selectedStatus"
                              :rules="[rules.required]"
                              @change="handleSelectedStatusChange(trigger)"
                              @focus="updateValidStatus(trigger)"
                              tabindex="0"
                          >
                            <template v-slot:selection="{ item }">
                              <div class="v-select__selection v-select__selection--comma selection-container">
                                <span class="substatus"><i :class="statusToIcon(item.extra.condition.id)" class="fa-fw ad-status-icon" aria-hidden="true"></i><span class="status-text">{{ item.text || item }}</span></span>
                              </div>
                            </template>
                            <template v-slot:item="{ item }">
                              <div class="item-container">
                                <span class="substatus"><i :class="statusToIcon(item.extra.condition.id)" class="fa-fw ad-status-icon" aria-hidden="true"></i><span class="status-text">{{ item.text || item }}</span></span>
                              </div>
                            </template>
                          </v-select>
                          <span v-if="!isEvent" class="field-inline-label"
                                :class="isEditMode?'mr-2':''"
                          >when the {{ selectedCategoryMetadata.name }} Metric Value</span>
                          <span v-if="isEvent" class="field-inline-label"
                                :class="isEditMode?'mr-2':''"
                          >when the <span class="group-info">matching event's duration</span> is at least</span>
                          <v-select
                              v-if="!isEvent"
                              :items="operations"
                              :disabled="isViewMode"
                              dense
                              outlined
                              single-line
                              hide-details
                              :menu-props="{ maxHeight:'75%' }"
                              :append-icon="isEditMode ? 'fal fa-chevron-down' : ''"
                              class="select-field select-field-highlight flex-grow-0 flex-shrink-0"
                              :class="isEditMode?'mr-2':''"
                              placeholder="Select"
                              v-model="operation"
                              :rules="[rules.required]"
                              @change="handleOperationChange"
                          ></v-select>
                          <span v-if="uniqueThreshold && !isEvent" class="field-inline-label field-inline-highlight mr-2 status-text">zero</span>
                          <v-text-field 
                              v-if="!uniqueThreshold && !isEvent"
                              :disabled="isViewMode"
                              :ref="'thresholdTextField-'+trigger.id"
                              class="small-text-field threshold-field threshold-field-critical mr-2"
                              :class="statusToThresholdFieldClass(trigger.selectedStatus)"
                              outlined
                              dense
                              single-line
                              hide-details
                              :error="thresholdError"
                              v-on:keypress="isShortInteger($event, trigger.threshold)"
                              v-on:blur="validateThresholdInput"
                              v-model="trigger.threshold"
                              @input="handleThresholdChange(trigger)"
                              :rules="[rules.requiredOneThresholdAndThresholdOrdered]"
                          ></v-text-field>
                          <span v-if="!isEvent" class="field-inline-label"
                                :class="isEditMode?'mr-2':''"
                          >for</span>
                          <v-text-field
                              class="small-text-field minutes-input"
                              :class="isEditMode?'mr-2':''"
                              :disabled="isViewMode"
                              outlined
                              dense
                              single-line
                              hide-details
                              v-on:keypress="isTripleInteger($event, duration)"
                              v-model.number="duration"
                              :rules="isEvent?[rules.integer]:[rules.required, rules.integer]"
                          ></v-text-field>
                          <span class="field-inline-label"><span v-if="!isEvent">consecutive </span>minutes</span>
                          <span v-if="isCdrMetric">,&nbsp;</span>
                          <span v-if="isCdrMetric" class="field-inline-label"
                                :class="isEditMode?'mr-2':''"
                          >during the last</span>
                          <v-text-field 
                              v-if="isCdrMetric"
                              class="small-text-field"
                              :class="isEditMode?'mr-2':''"
                              :disabled="isViewMode"
                              outlined
                              dense
                              single-line
                              hide-details
                              v-on:keypress="isSingleInteger($event, window)"
                              v-model.number="window"
                              :rules="[rules.required, rules.integer]"
                          ></v-text-field>
                          <span v-if="isCdrMetric" class="field-inline-label">hour window</span>
                          <span v-if="isEditMode && !uniqueThreshold && triggers.length > 1" class="ml-3 mr-3">
                            <a
                                class="notification-action-toolbar-btn"
                                role="button"
                                @click="onDeleteTrigger(trigger, index)"
                            >
                              <i class="trigger-action-toolbar-icon fal fa-minus-circle"/>
                              <span class="sr-only">Delete Trigger</span>
                            </a>
                          </span>
                          <span v-if="isEditMode && !uniqueThreshold && triggers.length <= 1" class="ml-3 mr-3">
                            <i class="trigger-action-toolbar-icon-disabled fal fa-minus-circle"/>
                          </span>
                          <span v-if="isEditMode && !uniqueThreshold && triggers.length < 3" >
                            <a
                                class="notification-action-toolbar-btn"
                                role="button"
                                @click="onAddTrigger(trigger, index)"
                            >
                              <i class="trigger-action-toolbar-icon fal fa-plus-circle" />
                              <span class="sr-only">Add Trigger</span>
                            </a>
                          </span>
                          <span v-if="isEditMode && !uniqueThreshold && triggers.length >= 3" >
                            <i class="trigger-action-toolbar-icon-disabled fal fa-plus-circle" />
                          </span>
  
                        </div>
                      </v-col>
                    </div></v-container>
                    <v-divider v-if="typeSet"></v-divider>
                  </section>
              </div>
              <div class="vy-row table-row flex-nowrap ma-0 table-header-row">
                <svg v-if="typeSet && isEditMode" class="table-cell-0 edit-instructions-svg" width="24" height="24">
                  <circle class="edit-instructions-circle" cx="12" cy="12" r="12"></circle>
                  <text class="edit-instructions-text" x="50%" y="50%" dy="0.33em">3</text>
                </svg>
                <v-container fluid class="table-cell-1"><div class="vy-row">
                    <v-col cols=auto>
                      <div class="vy-row">
                        <v-col>
                          <div class="vy-row instructions-section-header-row">
                            <span v-if="typeSet && isEditMode" class="instructions-section-header-text">Notify your team</span>
                            <span v-if="typeSet && isViewMode" class="instructions-section-header-text">Notify</span>
                          </div>
                        </v-col>
                      </div>
                    </v-col>
                  </div></v-container>
              </div>
              <div class="vy-row table-row flex-nowrap ma-0">
                <svg v-if="typeSet && isEditMode" class="table-cell-0 edit-instructions-svg" width="24" height="24">
                </svg>
                <section class="table-cell-1 notificationSelection">
                    <v-container fluid id="notificationSelection"><div class="vy-row">
                      <v-col>
                        <div class="vy-row flex-nowrap" v-if="typeSet" >
                          <v-col cols="12">
                            <div class="vy-row">
                              <v-card
                                  outlined
                                  width="100%"
                                  class="preselection-message">
                                <v-card-subtitle
                                  v-if="!blockThresholdAndNotifications && ( !anyThresholdsFilledIn || !thresholdsOrdered || !singleNEThreshold )"
                                >
                                  You must fill in {{operation === 'ne' ? ' a ' : ''}} Threshold amount{{operation === 'ne' ? '' : 's'}} for Critical, Warn or Info ({{operation === 'ne' ? 'only one' : 'in the proper order'}})
                                </v-card-subtitle>
                                <v-card-subtitle
                                  v-if="blockThresholdAndNotifications && ( !anyThresholdsFilledIn || !thresholdsOrdered || !singleNEThreshold )"
                                >
                                  You must select the Category and Metric first
                                </v-card-subtitle>
  
                                <v-tabs
                                  v-if="!blockThresholdAndNotifications && anyThresholdsFilledIn && thresholdsOrdered && singleNEThreshold"
                                  v-model="notificationTab"
                                  background-color="transparent"
                                  :class="tabDynamicColor"
                                  class="notification-tabs"
                                  align-with-title
                                >
                                  <v-tab
                                      :disabled="!item.threshold"
                                      v-for="(item, key, index) in conditionsAndNotificationItems"
                                      :key="item.id"
                                      :ripple="false"
                                      :class="item.class"
                                      class="condition-tab"
                                  >
                                    <i :class="statusToIcon(item.id)" class="fa-fw ad-status-icon" aria-hidden="true"></i><span class="regular-text"><span class="status-text">{{ item.name }}</span>&nbsp;(<span v-if="item.notifications.length === 0">0</span><span v-if="item.notifications.length > 0 && enabledCount(item.notifications) < item.notifications.length">{{enabledCount(item.notifications)}} of {{item.notifications.length}}</span><span v-if="item.notifications.length > 0 && enabledCount(item.notifications) === item.notifications.length">{{item.notifications.length}}</span>)</span>
                                  </v-tab>
                                </v-tabs>
  
                                <v-tabs-items
                                    v-if="!blockThresholdAndNotifications && anyThresholdsFilledIn && thresholdsOrdered && singleNEThreshold"
                                    v-model="notificationTab">
                                  <v-tab-item
                                      v-for="item in conditionsAndNotificationItems"
                                      :key="item.id"
                                      transition="false"
                                      reverse-transition="false"
                                  >
                                    <v-container fluid class="tab-container notifications-container">
                                      <div v-if="isEditMode && item.notifications.length === 0">
                                        <div class="ma-2 add-notification-text">Add notification type</div>
                                        <v-btn
                                            class="ma-2 notification-tool-btn"
                                            style="height: 100%; width: 150px;"
                                            outlined
                                            color="#D0D0D0"
                                            @click="onAddNotification(item.notifications, 0, 'EMAIL')"
                                        >
                                          <v-container fluid>
                                            <v-col>
                                              <div class="vy-row column-center"style="margin-bottom:5px;">
                                                <v-icon x-large class="notification-tool-btn">fal fa-plus-circle</v-icon>
                                              </div>
                                              <div class="vy-row column-center" >
                                                <v-icon small class="notification-tool-btn">fa-fw fal fa-envelope</v-icon>
                                                <span class="add-notification-btn-text">Email</span>
                                              </div>
                                            </v-col>
                                          </v-container>
                                        </v-btn>
                                        <v-btn
                                            class="ma-2 ml-9 notification-tool-btn"
                                            style="height: 100%; width: 150px;"
                                            outlined
                                            color="#D0D0D0"
                                            @click="onAddNotification(item.notifications, 0, 'WEBHOOK')"
                                        >
                                          <v-container fluid>
                                            <v-col>
                                              <div class="vy-row column-center" style="margin-bottom:5px;">
                                                <v-icon x-large class="notification-tool-btn">fal fa-plus-circle</v-icon>
                                              </div>
                                              <div class="vy-row column-center">
                                                <v-icon small class="notification-tool-btn">fa-fw fal fa-globe</v-icon>
                                                <span class="add-notification-btn-text">Webhook</span>
                                              </div>
                                            </v-col>
                                          </v-container>
                                        </v-btn>
                                      </div>
                                      <v-form
                                        :disabled="!item.threshold"
                                        class="notificationSelectionTab"
                                        v-for="(notification, index) in item.notifications"
                                        :key="notification.uid"
                                        @submit.prevent
                                      >
                                        <v-card outlined color="#6D787E">
                                          <v-card flat color="ffffff">
                                            <v-toolbar dense flat height="38px" class="notificationHeader">
                                              <v-checkbox
                                                  v-if="isEditMode"
                                                  name="notificationEnabled"
                                                  dense
                                                  dark
                                                  hide-details
                                                  :ripple="false"
                                                  v-model="notification.enabled"
                                                  :disabled="!isEditMode || !item.threshold"
                                                  v-on:click.stop="doNothing"
                                                  class="notification-title"
                                              >
                                              </v-checkbox>
  
                                              <span v-if="!demo && notification.action === 'WEBHOOK'" class="new-beta badge">beta</span>
                                              <v-icon small class="notification-title-icon">{{notificationIcon(notification.action)}}</v-icon>
                                              <v-toolbar-title class="notification-title">Notification {{index+1}} of {{item.notifications.length}}<span v-if="!isEditMode && notification.enabled"> (Enabled)</span><span v-if="!isEditMode && !notification.enabled"> (Disabled)</span></v-toolbar-title>
                                              <v-spacer></v-spacer>
                                              <v-toolbar-title class="notification-webhook-help" v-if="isEditMode && notification.action === 'WEBHOOK'">Need Webhook help? Read <a class="excluded articleLink" :href="brandingService.getSupportUrl('webhooksSetup')" target='_blank'>this article</a> to get started.</v-toolbar-title>
  
                                              <a
                                                  v-if="isEditMode"
                                                  name="deleteNotification"
                                                  class="notification-action-toolbar-btn"
                                                  role="button"
                                                  tabindex="0"
                                                  @click="onDeleteNotification(item.notifications, index)"
                                                  @keyup.enter="onDeleteNotification(item.notifications, index)"
                                              >
                                                <i class="notification-action-toolbar-icon far fa-minus-circle" />
                                                <span class="sr-only">Delete Notification</span>
                                              </a>
  
                                              <v-menu
                                                  content-class="addNotificationMenuContent"
                                                  bottom
                                                  left
                                                  nudge-bottom="13px"
                                                  nudge-left="11px"
                                                  v-if="isEditMode"
                                              >
                                                <template v-slot:activator="{ on, attrs }">
                                                  <a
                                                      class="notification-action-toolbar-btn"
                                                      role="button"
                                                      tabindex="0"
                                                      v-bind="attrs"
                                                      v-on="on"
                                                      @keyup.enter="on.click"
                                                  >
                                                    <i class="notification-action-toolbar-icon far fa-plus-circle" />
                                                    <span class="sr-only">Add Notification</span>
                                                  </a>
                                                </template>
  
                                                <v-list>
                                                  <v-list-item name="addEmailNotification" @click="onAddNotification(item.notifications, index, 'EMAIL')" class="filterMenuListItem">
                                                    <v-icon small>fa-fw far fa-envelope</v-icon>
                                                    <span class="filterMenuListItemText">Add Email Notification</span>
                                                  </v-list-item>
                                                  <v-divider></v-divider>
                                                  <v-list-item name="addWebhookNotification" @click="onAddNotification(item.notifications, index, 'WEBHOOK')" class="filterMenuListItem">
                                                    <v-icon small>fa-fw far fa-globe</v-icon>
                                                    <span class="filterMenuListItemText">Add Webhook Notification</span>
                                                  </v-list-item>
                                                </v-list>
                                              </v-menu>
  
                                              </v-toolbar>
                                            <v-container fluid>
                                              <div class="vy-row notificationSelectionTabEdit" v-if="isEditMode">
                                                <v-col cols="12" lg="6" class="col note-first-col">
                                                  <div class="vy-row">
                                                    <span v-if="notification.action !== 'WEBHOOK'" class="field-label">Subject</span>
                                                    <span v-if="notification.action === 'WEBHOOK'" class="field-label">Name</span>
                                                  </div>
                                                  <div class="vy-row">
                                                    <v-text-field
                                                        v-model="notification.name"
                                                        name="Notification Title"
                                                        outlined
                                                        dense
                                                        single-line
                                                        hide-details
                                                        :placeholder="currentTitle"
                                                    >
                                                    </v-text-field>
                                                  </div>
                                                  <div class="vy-row">
                                                    <span v-if="notification.action !== 'WEBHOOK'" class="field-label">To (recipient)</span>
                                                    <span v-if="notification.action === 'WEBHOOK'" class="field-label">URL</span>
                                                  </div>
                                                  <div class="vy-row">
                                                    <v-text-field
                                                        v-if="notification.action !== 'WEBHOOK'"
                                                        name="Notification Recipients"
                                                        v-model="notification.recipients"
                                                        :rules="[rules.email]"
                                                        outlined
                                                        dense
                                                        single-line
                                                        hide-details
                                                    >
                                                    </v-text-field>
                                                    <v-text-field
                                                        v-if="notification.action === 'WEBHOOK'"
                                                        name="Notification URLs"
                                                        v-model="notification.recipients"
                                                        :rules="[rules.url]"
                                                        outlined
                                                        dense
                                                        single-line
                                                        hide-details
                                                    >
                                                    </v-text-field>
                                                  </div>
                                                </v-col>
                                                <v-col cols="12" lg="6" class="col note-last-col">
                                                  <div class="vy-row flex-nowrap">
                                                    <v-col>
                                                      <div class="vy-row">
                                                        <span class="field-label">Frequency</span>
                                                      </div>
                                                      <div class="vy-row">
                                                        <v-select
                                                            name="Notification Frequency"
                                                            v-model="notification.frequency"
                                                            :items="frequencies"
                                                            dense
                                                            outlined
                                                            single-line
                                                            hide-details
                                                            :menu-props="{ maxHeight:'75%' }"
                                                            append-icon="fal fa-chevron-down"
                                                            class="select-field"
                                                            placeholder="Select"
                                                        >
                                                        </v-select>
                                                      </div>
                                                    </v-col>
                                                    <v-col>
                                                      <div class="vy-row ma-0" v-if="notification.action !== 'WEBHOOK'">
                                                        <span class="field-label">Email Type</span>
                                                      </div>
                                                      <div class="vy-row ma-0" v-if="notification.action !== 'WEBHOOK'">
                                                        <v-select
                                                            name="Email Type"
                                                            v-model="notification.format"
                                                            :items="['HTML', 'HTML - Custom']"
                                                            dense
                                                            outlined
                                                            single-line
                                                            hide-details
                                                            :menu-props="{ maxHeight:'75%' }"
                                                            append-icon="fal fa-chevron-down"
                                                            class="select-field"
                                                            placeholder="Select"
                                                        >
                                                        </v-select>
                                                      </div>
                                                    </v-col>
                                                  </div>
                                                  <div class="vy-row ma-0" v-if="notification.action !== 'WEBHOOK' && notification.format==='HTML - Custom'">
                                                    <span class="field-label">Email body</span>
                                                  </div>
                                                  <div class="vy-row ma-0" v-if="notification.action !== 'WEBHOOK' && notification.format==='HTML - Custom'">
                                                    <v-textarea
                                                        name="Email Body"
                                                        v-model="notification.customText"
                                                        class="email-body"
                                                        outlined
                                                        dense
                                                        auto-grow
                                                        single-line
                                                        hide-details
                                                        rows="3"
                                                    >
                                                    </v-textarea>
                                                  </div>
                                                  <div class="vy-row ma-0">
                                                    <v-col cols="6">
                                                      <div class="vy-row">
                                                        <span class="field-label">Days</span>
                                                      </div>
                                                      <div class="vy-row" align="center">
                                                        <v-btn-toggle class="day-selector"
                                                                      v-model="notification.scheduleDays"
                                                                      multiple
                                                        >
                                                          <v-btn :disabled="!item.threshold" small name="Sunday" :aria-checked="daySelectedBoolean(0, notification.scheduleDays).toString()">S</v-btn>
                                                          <v-btn :disabled="!item.threshold" small name="Monday" :aria-checked="daySelectedBoolean(1, notification.scheduleDays).toString()">M</v-btn>
                                                          <v-btn :disabled="!item.threshold" small name="Tuesday" :aria-checked="daySelectedBoolean(2, notification.scheduleDays).toString()">T</v-btn>
                                                          <v-btn :disabled="!item.threshold" small name="Wednesday" :aria-checked="daySelectedBoolean(3, notification.scheduleDays).toString()">W</v-btn>
                                                          <v-btn :disabled="!item.threshold" small name="Thursday" :aria-checked="daySelectedBoolean(4, notification.scheduleDays).toString()">T</v-btn>
                                                          <v-btn :disabled="!item.threshold" small name="Friday" :aria-checked="daySelectedBoolean(5, notification.scheduleDays).toString()">F</v-btn>
                                                          <v-btn :disabled="!item.threshold" small name="Saturday" :aria-checked="daySelectedBoolean(6, notification.scheduleDays).toString()">S</v-btn>
                                                        </v-btn-toggle>
                                                      </div>
                                                    </v-col>
                                                    <v-col cols="6">
                                                      <div class="vy-row ma-0">
                                                        <span class="field-label">Active Schedule ({{notification.timeZoneAbr}})</span>
                                                      </div>
                                                      <div class="vy-row  ma-0 flex-nowrap" align="center">
                                                          <v-menu
                                                              ref="startTimeMenu"
                                                              v-model="item.scheduleStartTimeMenu2"
                                                              :close-on-content-click="false"
                                                              transition="scale-transition"
                                                              contentClass="time-picker-menu-item"
                                                              offset-y
                                                          >
                                                            <template v-slot:activator="{ on, attrs }">
                                                              <v-text-field
                                                                  v-model="notification.scheduleStartTime"
                                                                  name="Schedule Start Time"
                                                                  class="time-picker-field"
                                                                  readonly
                                                                  outlined
                                                                  dense
                                                                  single-line
                                                                  hide-details
                                                                  v-bind="attrs"
                                                                  v-on="on"
                                                              ></v-text-field>
                                                            </template>
                                                            <timePicker
                                                                v-if="item.scheduleStartTimeMenu2"
                                                                label="Start Time"
                                                                :hours="parseInt(notification.scheduleStartTime.split(':')[0])"
                                                                :minutes="parseInt(notification.scheduleStartTime.split(':')[1])"
                                                                @time-change="updateStarttime($event, notification)"
                                                            />
                                                          </v-menu>
                                                          <span class="time-to">to</span>
                                                          <v-menu
                                                              ref="endTimeMenu"
                                                              v-model="item.scheduleEndTimeMenu2"
                                                              name="Schedule End Time"
                                                              :close-on-content-click="false"
                                                              transition="scale-transition"
                                                              contentClass="time-picker-menu-item"
                                                              offset-y
                                                          >
                                                            <template v-slot:activator="{ on, attrs }">
                                                              <v-text-field
                                                                  v-model="notification.scheduleEndTime"
                                                                  class="time-picker-field"
                                                                  name="Schedule End Time"
                                                                  readonly
                                                                  outlined
                                                                  dense
                                                                  single-line
                                                                  hide-details
                                                                  v-bind="attrs"
                                                                  v-on="on"
                                                              ></v-text-field>
                                                            </template>
                                                            <timePicker
                                                                v-if="item.scheduleEndTimeMenu2"
                                                                label="End Time"
                                                                name="Schedule End Time"
                                                                :hours="parseInt(notification.scheduleEndTime.split(':')[0])"
                                                                :minutes="parseInt(notification.scheduleEndTime.split(':')[1])"
                                                                @time-change="updateEndtime($event, notification)"
                                                            />
                                                          </v-menu>
  
                                                      </div>
                                                    </v-col>
                                                  </div>
                                                </v-col>
                                              </div>
                                              <div class="vy-row notificationSelectionTabEdit data" v-if="isEditMode && notification.action === 'WEBHOOK'">
                                                <v-col cols="12" class="col">
                                                  <div class="vy-row">
                                                    <v-col>
                                                      <div class="vy-row">
                                                        <span class="field-label">Data</span>
                                                        <span class="templateButtons">
                                                          <span class="insertLabel">Insert sample for: </span>
                                                          <span v-for="sample in webhookSamples" class="sample" @click="insertSample(notification, sample.value)" tabindex="0" @keyup.enter="insertSample(notification, sample.value)" role="button">
                                                            <img class="logo" :src="sample.iconUrl" alt="sample icon" />{{sample.name}}</span>
                                                        </span>
                                                      </div>
                                                      <div class="vy-row">
                                                        <v-textarea
                                                            :ref="'ta-'+notification.uid"
                                                            v-model="notification.customText"
                                                            name="Data"
                                                            class="data-body"
                                                            outlined
                                                            dense
                                                            auto-grow
                                                            single-line
                                                            hide-details
                                                            rows="10"
                                                        >
                                                          <template v-slot:append>
                                                            <v-menu
                                                                content-class="insertMenuContent"
                                                                :close-on-content-click="false"
                                                                bottom
                                                                left
                                                                nudge-bottom="13px"
                                                                nudge-left="11px"
                                                            >
                                                              <template v-slot:activator="{ on, attrs }">
                                                                <v-fab-transition>
                                                                  <v-btn
                                                                      name="Options"
                                                                      dark
                                                                      color="#6D787E"
                                                                      x-small
                                                                      icon
                                                                      fab
                                                                      absolute
                                                                      top
                                                                      right
                                                                      v-on="on"
                                                                      v-bind="attrs"
                                                                      @click="taFocus(notification)"
                                                                  >
                                                                    <v-icon dark small>far fa-ellipsis-h</v-icon>
                                                                  </v-btn>
                                                                </v-fab-transition>
                                                              </template>
                                                              <v-list>
  
                                                                <v-menu
                                                                    content-class="insertMenuContent"
                                                                    left
                                                                    offset-x
                                                                    open-on-hover
                                                                >
                                                                  <template v-slot:activator="{ on, attrs }">
                                                                    <v-list-item
                                                                        v-on="on"
                                                                        v-bind="attrs"
                                                                        @click="taFocus(notification)"
                                                                        :ripple="false"
                                                                        class="filterMenuListItem"
                                                                    >
                                                                      <v-list-item-content>
                                                                        <span class="filterMenuListItemText">Insert Common Variable</span>
                                                                      </v-list-item-content>
                                                                      <v-list-item-icon><v-icon x-small>fal fa-chevron-right</v-icon></v-list-item-icon>
                                                                    </v-list-item>
                                                                  </template>
                                                                  <v-list>
                                                                    <v-list-item
                                                                        v-for="variable in webhookCommonVariablesFiltered"
                                                                        :key="variable.value"
                                                                        @click="insertVariable(notification, variable.value)"
                                                                        :ripple="false"
                                                                        class="filterMenuListItem"
                                                                    >
                                                                      <span class="filterMenuListItemText">{{ variable.name }}</span>
                                                                    </v-list-item>
                                                                  </v-list>
                                                                </v-menu>
  
                                                                <v-divider></v-divider>
  
                                                                <v-menu
                                                                    content-class="insertMenuContent"
                                                                    left
                                                                    offset-x
                                                                    open-on-hover
                                                                >
                                                                  <template v-slot:activator="{ on, attrs }">
                                                                    <v-list-item
                                                                        v-on="on"
                                                                        v-bind="attrs"
                                                                        @click="taFocus(notification)"
                                                                        :ripple="false"
                                                                        class="filterMenuListItem"
                                                                    >
                                                                      <v-list-item-content>
                                                                        <span class="filterMenuListItemText">Insert Other Variable</span>
                                                                      </v-list-item-content>
                                                                      <v-list-item-icon><v-icon x-small>fal fa-chevron-right</v-icon></v-list-item-icon>
                                                                    </v-list-item>
                                                                  </template>
                                                                  <v-list>
                                                                    <v-list-item
                                                                        v-for="variable in webhookOtherVariablesFiltered"
                                                                        :key="variable.value"
                                                                        @click="insertVariable(notification, variable.value)"
                                                                        :ripple="false"
                                                                        class="filterMenuListItem"
                                                                    >
                                                                      <span class="filterMenuListItemText">{{ variable.name }}</span>
                                                                    </v-list-item>
                                                                  </v-list>
                                                                </v-menu>
  
                                                                <v-menu
                                                                    content-class="insertMenuContent"
                                                                    left
                                                                    offset-x
                                                                    open-on-hover
                                                                    v-if="webhookSourceVariablesFiltered.length > 0"
                                                                >
                                                                  <template v-slot:activator="{ on, attrs }">
                                                                    <v-list-item
                                                                        v-on="on"
                                                                        v-bind="attrs"
                                                                        @click="taFocus(notification)"
                                                                        :ripple="false"
                                                                        class="filterMenuListItem"
                                                                    >
                                                                      <v-list-item-content>
                                                                        <span class="filterMenuListItemText">Insert Endpoint Variable</span>
                                                                      </v-list-item-content>
                                                                      <v-list-item-icon><v-icon x-small>fal fa-chevron-right</v-icon></v-list-item-icon>
                                                                    </v-list-item>
                                                                  </template>
                                                                  <v-list>
                                                                    <v-list-item
                                                                        v-for="variable in webhookSourceVariablesFiltered"
                                                                        :key="variable.value"
                                                                        @click="insertVariable(notification, variable.value)"
                                                                        :ripple="false"
                                                                        class="filterMenuListItem"
                                                                    >
                                                                      <span class="filterMenuListItemText">{{ variable.name }}</span>
                                                                    </v-list-item>
                                                                  </v-list>
                                                                </v-menu>
  
                                                              </v-list>
                                                            </v-menu>
                                                          </template>
                                                        </v-textarea>
                                                      </div>
                                                    </v-col>
                                                  </div>
                                                </v-col>
                                              </div>
                                              <div class="vy-row ma-0 flex-nowrap notificationSelectionTabView" v-if="isViewMode">
                                                <v-col>
                                                  <div class="vy-row">
                                                    <v-col cols="2">
                                                      <div class="vy-row">
                                                        <span v-if="notification.action !== 'WEBHOOK'" >Subject:</span>
                                                        <span v-if="notification.action === 'WEBHOOK'" >Name:</span>
                                                      </div>
                                                    </v-col>
                                                    <v-col cols="10">
                                                      <div class="vy-row">
                                                        <span>
                                                          {{ notification.name }}
                                                        </span>
                                                      </div>
                                                    </v-col>
                                                  </div>
                                                  <div class="vy-row">
                                                    <v-col cols="2">
                                                      <div class="vy-row">
                                                        <span v-if="notification.action !== 'WEBHOOK'" >To (recipient):</span>
                                                        <span v-if="notification.action === 'WEBHOOK'" >URL</span>
                                                      </div>
                                                    </v-col>
                                                    <v-col cols="10">
                                                      <div class="vy-row">
                                                        <span>
                                                      {{ notification.recipientsDisplay }}
                                                        </span>
                                                      </div>
                                                    </v-col>
                                                  </div>
                                                  <div class="vy-row" v-if="notification.action !== 'WEBHOOK'" >
                                                    <v-col cols="2">
                                                      <div class="vy-row ma-0">
                                                        <span>Email Type:</span>
                                                      </div>
                                                    </v-col>
                                                    <v-col cols="10">
                                                      <div class="vy-row ma-0">
                                                        <span>
                                                          {{ notification.format }}
                                                        </span>
                                                      </div>
                                                    </v-col>
                                                  </div>
                                                  <div class="vy-row">
                                                    <v-col cols="2">
                                                      <div class="vy-row">
                                                        <span>Frequency:</span>
                                                      </div>
                                                    </v-col>
                                                    <v-col cols="10">
                                                      <div class="vy-row">
                                                        <span>
                                                      {{ getFrequencyDisplayName(notification.frequency) }}
                                                        </span>
                                                      </div>
                                                    </v-col>
                                                  </div>
                                                  <div class="vy-row" v-if="notification.action !== 'WEBHOOK' && notification.format==='HTML - Custom'">
                                                    <v-col cols="2">
                                                      <div class="vy-row">
                                                        <span>Email body:</span>
                                                      </div>
                                                    </v-col>
                                                    <v-col cols="10">
                                                      <div class="vy-row">
                                                        <span>
                                                      {{ notification.customText }}
                                                        </span>
                                                      </div>
                                                    </v-col>
                                                  </div>
                                                  <div class="vy-row">
                                                    <v-col cols="2">
                                                      <div class="vy-row">
                                                        <span>Days:</span>
                                                      </div>
                                                    </v-col>
                                                    <v-col cols="10">
                                                      <div class="vy-row">
                                                        <span> <span :class="daySelected(0, notification.scheduleDays)">S</span> <span :class="daySelected(1, notification.scheduleDays)">M</span> <span :class="daySelected(2, notification.scheduleDays)">T</span> <span :class="daySelected(3, notification.scheduleDays)">W</span> <span :class="daySelected(4, notification.scheduleDays)">T</span> <span :class="daySelected(5, notification.scheduleDays)">F</span> <span :class="daySelected(6, notification.scheduleDays)">S</span>
                                                        </span>
                                                      </div>
                                                    </v-col>
                                                  </div>
                                                  <div class="vy-row">
                                                    <v-col cols="2">
                                                      <div class="vy-row ma-0">
                                                        <span>Active Schedule ({{notification.timeZoneAbr}}):</span>
                                                      </div>
                                                    </v-col>
                                                    <v-col cols="10">
                                                      <div class="vy-row ma-0">
                                                        <span>
                                                        {{ notification.scheduleStartTime }} -{{ notification.scheduleEndTime }}
                                                        </span>
                                                      </div>
                                                    </v-col>
                                                  </div>
                                                  <div class="vy-row" v-if="notification.action === 'WEBHOOK'">
                                                    <v-col cols="2">
                                                      <div class="vy-row">
                                                        <span>Data:</span>
                                                      </div>
                                                    </v-col>
                                                    <v-col cols="10">
                                                      <div class="vy-row">
                                                        <v-textarea
                                                            v-model="notification.customText"
                                                            class="data-body data-body-readonly"
                                                            outlined
                                                            dense
                                                            auto-grow
                                                            single-line
                                                            hide-details
                                                            readonly
                                                            rows="1"
                                                        >
                                                        </v-textarea>                                                  </div>
                                                    </v-col>
                                                  </div>
                                                </v-col>
                                              </div>
                                            </v-container>
                                          </v-card>
                                        </v-card>
                                      </v-form>
                                    </v-container>
                                  </v-tab-item>
                                </v-tabs-items>
                              </v-card>
                            </div>
                          </v-col>
                        </div>
                      </v-col>
                    </div></v-container>
                  </section>
              </div>
              <div class="vy-row table-row flex-nowrap ma-0">
                <svg v-if="typeSet && isEditMode" class="table-cell-0 edit-instructions-svg" width="24" height="24">
                </svg>
                <section class="table-cell-1 confirmationButtonsSection">
                    <v-container fluid id="confirmationButtonsSection">
                      <v-row justify="end">
                        <v-col cols="auto">
                          <button
                              class="cancelButton btn btn-default"
                              @click="onCancel">
                            <span class="btn-text">{{ cancelBtnText }}</span>
                          </button>
                        </v-col>
                        <v-col cols="auto">
                          <div class="vy-row">
                            <info v-if="!isEditMode" ref="infoLoad"></info>
                            <confirm v-if="!isEditMode" ref="confirmLoadErrorDelete"></confirm>
                            <info v-if="isEditMode" ref="infoSave"></info>
                            <button
                                v-if="isEditMode"
                                class="saveButton btn btn-primary"
                                :disabled="!complete"
                                @click="onSave"
                            >
                              <span class="btn-text">Save</span>
                            </button>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
  
                  </section>
              </div>
            </v-col>
          </v-container>
        </div>
      </section>
    </section>
  </v-app>
</template>

<script>
import BrandingService from '../../../../services/branding.service';
import DataProvider from '../../../../app/data-framework/data-provider';
import WebResourceSecure from '../../../assurance/services/web-resource-secure.service';
import DataService from "../../services/data.service";
import DataSecureService from '../../services/data-secure.service';
import FilterExpressionService from "../../services/filter.expression.service";
import MetadataService from '../../../../services/metadata.service';
import _ from "lodash";
import FilterExpression from "../../../../vueComponents/filterExpression/src/filterExpression.vue";
import TimePicker from "../../../../vueComponents/timePicker/src/timePicker.vue";
import Modal from "../../../../vueComponents/modal/src/modal.vue";
import VueDatasetService from "../../../../services/vue-dataset-view.service";
import ImageService from "../../../../services/image.service";
import Confirm from "../dialogs/Confirm.vue";
import Info from "../dialogs/Info.vue";
import moment from "moment-timezone";
import AssuranceAlertService from "../../services/assurance.alert.service";
import AlertChart from "../../components/moi-alert-chart/alertChart.vue";
import AlertGroupStatus from "../../components/moi-alert-group-status/alertGroupStatus.vue";
import QualityFilters from "../../components/quality-filters/qualityFilters.vue";
import InteractiveVTooltip from "../../components/interactive-vtooltip/InteractiveVTooltip.vue"
import UtilsService from "../../../../services/utils.service";
import msteamsTemplate from "raw-loader!./msteams.template.txt";
import slackTemplate from "raw-loader!./slack.template.txt";
import webexTemplate from "raw-loader!./webex.template.txt";
import msteamsEventTemplate from "raw-loader!./msteams.event.template.txt";
import slackEventTemplate from "raw-loader!./slack.event.template.txt";
import webexEventTemplate from "raw-loader!./webex.event.template.txt";
import LoginService from "../../../../services/login.service";
import FilterMigrationService from "../../../../services/filter.migration.service";
import dvFilterService from '../../components/dataset/services/dv-filter.service';
import Rx from "../../../../thirdPartyForks/rx.all";

const EDIT = 'edit';
const VIEW = 'view';
const EVENT = 'event';


  // from kpi-n-trend-options.js
  function getDropdownOptions(options) {
    return _.map(options, function (option) {
      return { text: _.get(option, 'name', option), value: _.get(option, 'id', option), extra:  option };
    });
  }

  function getGroupByOptions(options) {
    function convertGroupByOptions(input) {
      return _.map(input, function (option) {
        return { text: _.get(option, 'groupByName', _.get(option, 'name', option)), value: _.get(option, 'id', option), unique: _.get(option, 'groupByUID')};
      });
    }
    
    let metadata = _.filter(options, function(o) { return !_.get(o, 'excludeAlertGroupBy'); });


    let uniqueList = convertGroupByOptions(_.filter(metadata, function(o) { return _.get(o, 'groupByUID'); }));
    uniqueList = _.sortBy(uniqueList, 'text'); // sort alphabetically
    if (uniqueList.length > 0) uniqueList.unshift({header:'Simple'});

    let list = convertGroupByOptions(_.filter(metadata, function(o) { return !_.get(o, 'groupByUID'); }));
    list = _.sortBy(list, 'text'); // sort alphabetically

    if (list.length > 0) {
      list.unshift({header:'Advanced'});
      list.unshift({divider: true});
    }
    uniqueList.push(...list);

    return uniqueList;
  }

  function getGroupBySimpleToolTip(options) {
    function convertGroupByOptions(input) {
      return _.map(input, function (option) {
        return _.get(option, 'groupByName', _.get(option, 'name', option));
      });
    }

    let metadata = _.filter(options, function(o) { return !_.get(o, 'excludeAlertGroupBy'); });


    let uniqueList = convertGroupByOptions(_.filter(metadata, function(o) { return _.get(o, 'groupByUID'); }));
    uniqueList = uniqueList.sort();
    if (uniqueList.length === 0) return "group";

    return uniqueList.join('/');
  }

  ///
  const UNTITLED = 'Untitled';

  function getEmptyFilterGroups() {
    return _.cloneDeep(FilterExpressionService.getDefaultFilterExpression());
  }

  function getEmptyFilterExpression() {
    return _.cloneDeep({ filterGroups: getEmptyFilterGroups(), operator: 'and' });
  }

  function buildFilterFromSelections(self) {
    let selectionTableDataIndex = VueDatasetService.getDataIndexFromMetadata(self.selectionDataset, self.datasetMetadata);

    let ids = self.translatedSelections.map(s => `"${selectionTableDataIndex}=${s.id}"`).join()
    let names = self.translatedSelections.map(s => s.name).join(', ')
    
    return {
      field: selectionTableDataIndex,
      fieldText: self.deviceFilterTypeDisplayName,
      type: 'metric',
      filterComplete: true,
      operatorText: 'is',
      operatorValue: 'quickPick',
      isQuickPick: true,
      widget: 'ids',
      data: {selections: self.translatedSelections},
      quickPickValues: self.translatedSelections,
      value: `tags=in=(${ids})`,
      queryVar: ids,
      text: self.deviceFilterTypeDisplayName + ' is (' + _.map(self.translatedSelections, 'name').join(', ') + ')',
      shortText: names,
      auto: true
    };
  }

  export default {
    name: 'alert-details',
    components: {
      'alert-chart': AlertChart,
      'alert-group-status': AlertGroupStatus,
      'quality-filters': QualityFilters,
      'filter-expression': FilterExpression,
      'timePicker': TimePicker,
      'confirm': Confirm,
      'info': Info,
      'modal': Modal,
      'i-v-tooltip': InteractiveVTooltip,
      // 'dial-back-input': DialBackInput
    },
    data: function() {
      return {
        autoRefresh: true,
        brandingService: BrandingService,
        currentId: this.id,
        currentType: this.type || 'metric',
        currentCategory: '',
        currentGroupBy: [],
        currentGroupByDisplay: [],
        currentGroupByColors: {},
        currentlySelectedTrigger: {},
        demo: LoginService.userObject.demo,
        selectedCategoryMetadata: null,
        selectedMetricMetadata: null,
        modelList: [],
        currentMetric: '',
        currentFilterRSQL: '',
        currentFilterModel: undefined,
        currentEventsFilterModel: undefined,
        eventSourceDatasetMetadata: undefined,
        currentEventSource: undefined,
        currentEventSourceFilterModel: undefined,
        currentFilterDescription: '',
        dynamicFilter: true,
        translatedSelections: [], // generic selection objects, e.g. { id: '123', name: 'my endpoint' }, instead of using dynamic keys
        currentTitle: this.title || '',
        status: '',
        statusDef: {},
        groupStatuses: [],
        operation: 'gt',
        oldOperation: 'gt',
        duration: 5,
        window: 0,
        enabled: true,
        triggers: [
          {
            id: UtilsService.generateID(),
            selectedStatus: 'ERROR',
            threshold: '',
          },
        ],
        conditionsAndNotificationItems: {
          critical: {
            id: "critical",
            name: "Critical",
            class: "condition-critical",
            thresholdFieldClass: "threshold-field-critical",
            color: "var(--bad-color)",
            scheduleStartTimeMenu2: false,
            scheduleEndTimeMenu2: false,
            threshold: '',
            notifications: [],
          },
          warn: {
            id: "warn",
            name: "Warn",
            class: "condition-warn",
            thresholdFieldClass: "threshold-field-warn",
            color: "var(--fair-color)",
            scheduleStartTimeMenu2: false,
            scheduleEndTimeMenu2: false,
            threshold: '',
            notifications: [],
          },
          info: {
            id: "info",
            name: "Info",
            class: "condition-info",
            thresholdFieldClass: "threshold-field-info",
            color: "var(--neutral-color)",
            scheduleStartTimeMenu2: false,
            scheduleEndTimeMenu2: false,
            threshold: '',
            notifications: [],
          },
        },
        notificationTab: 0,
        metadata: {},
        datasetMetadata: {},
        systemMetrics: {},
        categories: [],
        groupBys: [],
        // selectedUniqueThreshold: '',
        frequencies: [{ text: 'Once per state change', value: 'once' }],
        metrics: [],
        rules: {
          required: value => {
            return !!value || 'Required.';
          },
          integer: value => {
            const pattern = /^[0-9]+$/;
            return pattern.test(value) || 'Invalid number.';
          },
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))(\s*\,\s*(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))*$/;
            return pattern.test(value) || 'Invalid e-mail.';
          },
          url: value => {
            const pattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
            return pattern.test(value) || 'Invalid URL.';
          },
          requiredOneThresholdAndThresholdOrdered: value => {
            let self = this;
            if (self.$el) { // if mounted
              self.thresholdError = !self.anyThresholdsFilledIn && !self.thresholdsOrdered && !self.singleNEThreshold;
            }
            return true; // don't set false or error-messages is overridden and no longer reactive
          },
        },
        thresholdError: false,

        filterColumns: [],
        eventFilterColumns: [],
        eventSourceFilterColumns: [],
        modalOutsideClickWhitelist: ['autocomplete-result', 'addFilterGroup', 'addFilter', 'center-pill', 'fa-plus-circle', 'pill', 'pillbox', 'operator', 'remove-filter', 'delete', 'listValueDisplay', 'insertMenuContent', 'addNotificationMenuContent', 'filterMenuContent', 'filterMenuListItem', 'filterMenuListItemIcon', 'filterMenuListItemText'],
        deleting: false,
        saving: false,
        loading: true,
        internalUserOrScubaV1OptIn: DataProvider.getInstance().isInternalUser() || LoginService.userObject.featureFlags.ScubaV1OptIn , // to be removed
        internalUserOrEventsOptIn: DataProvider.getInstance().isInternalUser() || LoginService.userObject.featureFlags.EventsOptIn , // to be removed
        qualityFilters: undefined,

        webhookCommonVariables: [
          {name: 'Id', value: 'alertId', type:['event', 'metric']},
          {name: 'Name', value: 'name', type:['event', 'metric']},
          {name: 'Description', value: 'description', type:['event', 'metric']},
            
          {name: 'Source Type', value: 'sourceType', type:['event']},

          {name: 'Source Id', value: 'sourceId', type: ['event']},
          {name: 'Source Name', value: 'sourceName', type: ['event']},
          {name: 'Source Details', value: 'sourceDetails', type: ['event']},
          {name: 'Event Type', value: 'eventType', type: ['event']},
          {name: 'Event Level', value: 'eventLevel', type: ['event']},
          {name: 'Event Message', value: 'eventMessage', type: ['event']},
          {name: 'Event Start Time', value: 'eventStartTime', type: ['event']},
          {name: 'Event End Time', value: 'eventEndTime', type: ['event']},
          {name: 'Event Last Seen Time', value: 'eventLastSeenTime', type: ['event']},

          {name: 'Status', value: 'status', type: ['event', 'metric']},
          {name: 'Status Color (hex)', value: 'statusColor', type:['event', 'metric']},
          {name: 'Category', value: 'category', type:['metric']},
          {name: 'Metric', value: 'metric', type:['metric']},
          {name: 'Fired Time (milliseconds)', value: 'alertFiredTimeMs', type:['event', 'metric']},
          {name: 'Operation', value: 'operation', type:['metric']},
          {name: 'Threshold', value: 'threshold', type:['metric']},
          {name: 'Monitor Duration', value: 'alertDurationMinutes', type:['event', 'metric']}, // todo should be duration for events
          {name: 'Window (hours)', value: 'lookbackDurationHours', type:['metric']},
          {name: 'Url', value: 'alertUrl', type:['event', 'metric']},
          {name: 'Group By', value: 'groupUniqueKey', type:['event', 'metric']},
          {name: 'Group', value: 'group', type:['event', 'metric']},
        ],
        webhookOtherVariables: [
          {name: 'Critical Threshold', value: 'errorThreshold', type:['metric']},
          {name: 'Warn Threshold', value: 'warnThreshold', type:['metric']},
          {name: 'Info Threshold', value: 'infoThreshold', type:['metric']},
          {name: 'Selected Items', value: 'selectedItems', type:['metric']},
          {name: 'Item Count', value: 'deviceCount', type:['metric']},
          {name: 'Status Start Time (milliseconds)', value: 'statusStartTimeMs', type:['event', 'metric']},
          {name: 'Created Time (milliseconds)', value: 'createdTimeMS', type:['event', 'metric']},
          {name: 'Created By Email', value: 'createdByEmail', type:['event', 'metric']},
          {name: 'Created By Name', value: 'createdByName', type:['event', 'metric']},
          {name: 'Modified Time (milliseconds)', value: 'modifiedTimeMs', type:['event', 'metric']},
          {name: 'Modified By Email', value: 'modifiedByEmail', type:['event', 'metric']},
          {name: 'Modified By Name', value: 'modifiedByName', type:['event', 'metric']},
          {name: 'Clear Duration (minutes)', value: 'okDurationMinutes', type:['event', 'metric']},
          {name: 'Group UID', value: 'groupUniqueValue', type:['event', 'metric']},
        ],
        webhookSourceVariables: [
          {name: 'Room Name', value: 'roomName', type:['event'], source:['endpoints']},
          {name: 'Room Floor', value: 'roomFloor', type:['event'], source:['endpoints']},
          {name: 'Room Type', value: 'roomType', type:['event'], source:['endpoints']},
          {name: 'Room System Type', value: 'roomEndpointType', type:['event'], source:['endpoints']},
          {name: 'Building Key', value: 'buildingKey', type:['event'], source:['endpoints']},
          {name: 'Building Name', value: 'buildingName', type:['event'], source:['endpoints']},
          {name: 'Building Region', value: 'buildingRegion', type:['event'], source:['endpoints']},
          {name: 'Building Country', value: 'buildingCountry', type:['event'], source:['endpoints']},
          {name: 'Building State', value: 'buildingState', type:['event'], source:['endpoints']},
          {name: 'Building City', value: 'buildingCity', type:['event'], source:['endpoints']},
          {name: 'Building Site', value: 'buildingSite', type:['event'], source:['endpoints']},
        ],
      };
    },
    computed: {
      webhookCommonVariablesFiltered: function() {
        let self = this;
        return self.webhookCommonVariables.filter(v => v.type.includes(self.currentType));
      },
      webhookOtherVariablesFiltered: function() {
        let self = this;
        return self.webhookOtherVariables.filter(v => v.type.includes(self.currentType));
      },
      webhookSourceVariablesFiltered: function() {
        let self = this;
        return self.webhookSourceVariables.filter(v => v.type.includes(self.currentType))
            .filter(v => v.source.includes('endpoints')); // todo filter on source type
      },
      webhookSamples: function() {
        let self = this;
        return [
        {
          name: 'MS Teams',
          iconUrl: 'dist/images/systems/40x40-ms-teams.png',
          value: self.isEvent ? msteamsEventTemplate : msteamsTemplate
        },
        {
          name: 'Slack',
          iconUrl: 'dist/images/systems/slack.png',
          value: self.isEvent ? slackEventTemplate : slackTemplate
        },
        {
          name: 'Webex',
          iconUrl: 'dist/images/systems/webex.png',
          value: self.isEvent ? webexEventTemplate : webexTemplate
        }
      ]},

      now: function() {
        let self = this;
        if (self.ts) {
          let futureNow = moment(self.ts).utc().add(2, 'hour');
          let now = moment().utc();
          if (futureNow.isAfter(now)) {
            return now;
          }
          return futureNow;
        }
        return moment().utc();
      },
      start: function() {
        return moment(this.now).subtract(4, 'hour').format('YYYY-MM-DDTHH:mm:ss') + 'Z';

      },
      end: function() {
        return this.now.format('YYYY-MM-DDTHH:mm:ss') + 'Z';
      },
      showThresholds: function() {
        return !!this.operation && this.singleNEThreshold && this.thresholdsOrdered;
      },
      chartHeight: function() {
        return this.isViewMode ? 300 : 200;
      },
      metricDisplay: function() {
        let self = this;
        return self.selectedMetricMetadata ? self.selectedMetricMetadata.name : '';
      },
      groupColors: function() {
        let self = this;
        return self.selectedGroupByMetadata ? _.get(self.selectedGroupByMetadata,'colors') : '';
      },
      categoryDisplay: function() {
        let self = this;
        return self.selectedCategoryMetadata ? self.selectedCategoryMetadata.name : '';
      },
      complete: function () {
        let self = this;
        if (self.isEvent) {
          return self.duration != null
              && self.duration !== ''
              && self.window != null
              && self.window !== ''
              && self.anyThresholdsFilledIn;
        }
        return self.currentCategory
            && self.currentMetric
            && self.operation
            && self.duration != null
            && self.duration !== ''
            && self.window != null
            && self.window !== ''
            && self.anyThresholdsFilledIn
            && self.singleNEThreshold
            && self.thresholdsOrdered;
      },
      operationDisplayName: function() {
        let self = this;
        return _.get(_.find(self.operations, op => op.value === self.operation),'text','');
      },
      dangerOnSelect: function () {
        let self = this;
        return self.currentFilterModel && self.currentFilterModel.filterGroups
            ? _.some(self.currentFilterModel.filterGroups, g => _.some(g.filters, f => !f.auto && f.value !== undefined))
            : false;
      },
      cancelBtnText: function() {
        let self = this;
        return 'edit' === self.mode ? 'Cancel' : 'Close';
      },
      isEditMode: function() {
        let self = this;
        return 'edit' === self.mode;
      },
      nonEditableInternalFilter: function() { // to be removed
        let self = this;
        return (!self.internalUserOrScubaV1OptIn && self.qualityFilters && !!FilterExpressionService.getFilterStringFromFilterExpression(self.qualityFilters, true))
            || (!self.internalUserOrEventsOptIn && self.isEvent);
      },
      isViewMode: function() {
        let self = this;
        return 'edit' !== self.mode;
      },
      isNew: function() {
        let self = this;
        return self.currentId === 'new';
      },
      isEvent: function() {
        let self = this;
        return self.currentType && self.currentType.startsWith(EVENT);
      },
      typeSet: function() {
        let self = this;
        return self.isNew || self.currentType;
      },
      blockThresholdAndNotifications: function() {
        let self = this;
        return !(self.currentMetric || self.isEvent);
      },
      tabDynamicColor: function() {
        let self = this;
        return _.get(_.values(self.conditionsAndNotificationItems)[self.notificationTab],'class', '');
      },
      statusColor: function () {
        if (this.status) {
          switch(this.status.toLowerCase()) {
            case 'ok': return '#4DB0EA';
            case 'info': return '#798388';
            case 'important': return '#E49C39';
            case 'warn': return '#E49C39';
            case 'critical': return '#DC5846';
            case 'error': return '#DC5846';
          }
        }
        return '#4DB0EA';
      },
      statusIcon: function () {
        return this.statusToIcon(this.status);
      },
      simpleQualityMode: function() {
        let self = this;
        // todo add to metadata so it's not hard coded
        return self.currentCategory === 'call' &&
            (self.currentMetric === 'calls_cdrs_total' || self.currentMetric === 'calls_rt_total' || self.currentMetric === 'call.quality.total');
      },
      selectionDataset: function() {
        let self = this;
        let datasetName = self.currentCategory;
        if (datasetName === 'bridges') {
          datasetName = 'systems';
        } else if (datasetName === 'callcontrol') {
          datasetName = 'systems';
        } else if (datasetName) {
          datasetName += 's';
        }
        return datasetName;
      },
      excludedQuickPicks: function() {
        if (this.simpleQualityMode && this.internalUserOrScubaV1OptIn) { // todo not sure this is right
          return { calls: { quality: true } };
        }
        return {};
      },
      datasetDisplayName: function() {
        let self = this;
        if (self.selectedCategoryMetadata) return _.lowerCase(self.selectedCategoryMetadata.name);
        else return self.selectionDataset;
      },
      deviceFilterTypeDisplayName: function() {
        let self = this;
        if (self.selectedCategoryMetadata) return self.selectedCategoryMetadata.name.slice(0, -1);
        else return _.upperFirst(self.selectionDataset.slice(0, -1));
      },
      isCdrMetric: function() {
        let self = this;
        let isCdr = false
        if (self.selectedMetricMetadata) {
          isCdr = _.get(self.selectedMetricMetadata, 'cdr', false);
        }
        // a bit if a hack setting window in a compute function
        if (isCdr && self.window === 0) self.window = 4;
        else if (!isCdr && self.window !== 0) self.window = 0;
        return isCdr;
      },
      selectionDatasetOuterFilter: function() {
        let self = this;
        let filter = '';
        if (self.currentCategory === 'bridges') {
          // todo setup filter - make sure this list is correct and we maintain it over time
          // todo it would be better to add this to metadata somewhere
          filter = 'type=in=('+self.modelList.join(',')+')'
        } else if (self.currentCategory === 'callcontrol') {
          // todo setup filter - make sure this list is correct and we maintain it over time
          // todo it would be better to add this to metadata somewhere
          filter = 'type=in=('+self.modelList.join(',')+')'
        }
        return filter;
      },
      listSelectButtonText: function() {
        let self = this;
        let text = `Select individual ${self.datasetDisplayName}`;
        if (self.translatedSelections.length) {
          text += ` - ${self.translatedSelections.length} ${self.datasetDisplayName} added`;
        }
        return text;
      },
      uniqueThreshold: function() {
        let self = this;

        // todo some summary metrics probably also should not use the unique UI as their values could be > 1
        return self.isEvent || (!self.systemMetrics[self.currentMetric] && _.some(self.currentGroupBy, gb => _.get(_.find(self.groupBys, { 'value' : gb}), 'unique') ) )
      },
      operations: function() {
        let self = this;
        if (self.uniqueThreshold) {
          return [
            // {text: 'Exists', value: 'gte'},
            // {text: 'Does not Exist', value: 'lt'},
            {text: 'is Greater than', value: 'gt'},
            {text: 'Equals', value: 'eq'},
          ];

        } else {
          return [
            {text: 'is Greater than', value: 'gt', disabled: self.uniqueThreshold},
            {text: 'is Greater than or Equals', value: 'gte'},
            {text: 'is Less than', value: 'lt'},
            {text: 'is Less than or Equals', value: 'lte', disabled: self.uniqueThreshold},
            {text: 'Equals', value: 'eq', disabled: self.uniqueThreshold},
            {text: 'does Not Equal', value: 'ne', disabled: self.uniqueThreshold},
          ];
        }
      },
      statuses: function() {
        let self = this;
        let results = [
          {text: 'Critical', value: 'ERROR', disabled: false, extra: {condition: self.conditionsAndNotificationItems.critical}},
          {text: 'Warn', value: 'WARN', disabled: false, extra: {condition: self.conditionsAndNotificationItems.warn}},
          {text: 'Info', value: 'INFO', disabled: false, extra: {condition: self.conditionsAndNotificationItems.info}},
        ];

        // disable any already selected triggers
        for (const trigger of self.triggers) {
          for (const result of results) {
            if (trigger.selectedStatus === result.value) {
              result.disabled = true;
            }
          }
        }
        
        // todo - this is not working
        // enable the currently selected trigger status
        // if (self.currentlySelectedTrigger && self.currentlySelectedTrigger.selectedStatus) {
        //   for (const result of results) {
        //     if (self.statusToCondition(self.currentlySelectedTrigger.selectedStatus) === result.extra.condition) {
        //       result.disabled = false;
        //     }
        //   }
        // }
        
        return results;
      },
      thresholdExtraSpace: function() {
        let self = this;
        if (!self.uniqueThreshold) {
          return 'threshold-extra-space';
        }
        return '';
      },
      anyThresholdsFilledIn: function() {
        let self = this;
        return _.values(self.conditionsAndNotificationItems).some(e => (e.threshold !== null && e.threshold !== ''));
      },
      singleNEThreshold: function() {
        let self = this;
        return !self.operation || self.operation != 'ne' || (_.countBy(self.conditionsAndNotificationItems, e => (e.threshold !== null && e.threshold !== '')?'ok':'null')['ok'] === 1);
      },
      thresholdsOrdered: function() {
        let self = this;

        let results = true;
        let criticalStr = self.conditionsAndNotificationItems.critical.threshold;
        let critical = parseInt(criticalStr);
        let warnStr = self.conditionsAndNotificationItems.warn.threshold;
        let warn = parseInt(warnStr);
        let infoStr = self.conditionsAndNotificationItems.info.threshold;
        let info = parseInt(infoStr);
        if (criticalStr && warnStr && critical === warn) results = false;
        if (criticalStr && infoStr && critical === info) results = false;
        if (infoStr && warnStr && info === warn) results = false;

        if (self.operation && (self.operation === 'lt' || self.operation === 'lte')) {
          if (criticalStr && warnStr && critical >= warn) results = false;
          if (criticalStr && infoStr && critical >= info) results = false;
          if (infoStr && warnStr && warn >= info) results = false;
        }

        if (self.operation && (self.operation === 'gt' || self.operation === 'gte')) {
          if (criticalStr && warnStr && critical <= warn) results = false;
          if (criticalStr && infoStr && critical <= info) results = false;
          if (infoStr && warnStr && warn <= info) results = false;
        }

        if (self.operation && (self.operation === 'eq' || self.operation === 'ne')) {
          if (criticalStr && warnStr && infoStr && critical < warn && info < warn) results = false;
          if (criticalStr && warnStr && infoStr && critical > warn && info > warn) results = false;
        }

        return results;
      },

      // currentEventsFilterDisplay: function () {
      //   return self.currentEventsFilterModel && self.currentEventsFilterModel.filterGroups && self.currentEventsFilterModel.filterGroups.length > 0
      //       ? FilterExpressionService.getFilterDisplayStringFromFilterExpression(self.currentEventsFilterModel) : 'All Events'
      // },
      // currentEventSourceFilterDisplay: function () {
      //   return self.currentEventSourceFilterModel && self.currentEventSourceFilterModel.filterGroups && self.currentEventSourceFilterModel.filterGroups.length > 0
      //       ? FilterExpressionService.getFilterDisplayStringFromFilterExpression(self.currentEventSourceFilterModel) : ''
      // },
    },
    created() {
      let self = this;

      const escapeHandler = (e) => {
        if (e.key === 'Escape') {
          // todo check on quick pick modal
          self.onCancel();
        }
      }

      document.addEventListener('keydown', escapeHandler);

      this.$once('hook:destroyed', () => {
        document.removeEventListener('keydown', escapeHandler);
      });

      MetadataService.fetchDatasetMetadataWithoutCategories().then(function (datasetMetadata) {
        self.datasetMetadata = datasetMetadata;
        DataService.fetchMetricsMetadata().then(function (metadata) {
          self.metadata = metadata;
          self.categories = getDropdownOptions(self.metadata);

          DataSecureService.fetchMetricModels().then(function (models) {
            self.modelsMetaData = models;

            if (self.currentId && !self.isNew) {
              self.loadExistingAlertData();

              if (self.isViewMode) {
                self.timerObservable = Rx.Observable.timer(60000, 60000)
                    .subscribe(function () {
                      self.loadExistingAlertData();
                    });
              }

            } else if (self.currentId && self.isNew) {
              if (self.isEvent) {
                self.currentCategory = self.type;
                self.setupEventFilter();

                self.currentGroupBy = 'source_type,source_id,event_type,event_level,start_time,unique_message'.split(','); // this is also hard coded in alert configuration service
                self.handleGroupByChange();
                
                self.updateUniqueThresoldObjectModel();
              } else {
                self.currentCategory = self.category;
                // update metrics list
                self.handleCategoryChange(); // requires self.modelsMetaData
                self.currentMetric = self.metric;
                self.handleMetricChange();

                self.currentFilterModel = self.filter; // todo I'm not sure if self.currentFilterModel.filterGroups is dynamic
                if (self.currentFilterModel) {
                  self.currentFilterRSQL = FilterExpressionService.getFilterStringFromFilterExpression(
                      self.currentFilterModel, true)

                  // todo support qualityFilter

                  self.updateCurrentFilterDescription();
                } else {
                  self.currentFilterModel = { filterGroups: VueDatasetService.getQuickStartFilterGroups(self.currentCategory + '-monitors', self.selectedCategoryMetadata), operator: 'and' };
                }
                

                self.currentGroupBy = self.groupBy;
                self.handleGroupByChange();
              }
              self.currentTitle = self.title || UNTITLED;
              let email = LoginService.userObject.email;
              if ( _.startsWith(email, 'vyoptaadmin@') || (email === 'support@vyopta.com') ) {
                email = '';
              }
              
              self.$nextTick(() => self.loading = false);
            }
          });
        });
      });

    },
    mounted(){
      let self = this;
      if (self.isNew) {
        setTimeout(() => {
        // self.$nextTick(() => {
          self.$refs.titleTextField.$el.querySelector('input').focus();
          self.$refs.titleTextField.$el.querySelector('input').select();
        }, 500);
      } else if (self.currentId) {
        if (self.autoRefresh) {
          
        }
      }
    },
    beforeDestroy() { // vue 2.0 (deprecated in 3.0)
      let self = this;
      if (self.timerObservable) self.timerObservable.dispose();
    },
    beforeUnmount() { // vue 3.0
      let self = this;
      if (self.timerObservable) self.timerObservable.dispose();
    },
    methods: {
      testFunction: function(on, attrs) {
        on.click();
      },
      loadExistingAlertData: function () {
        let self = this;
        self.loading = true;
        DataProvider.getInstance().fetchAssuranceAlertConfigServiceBaseURL().then(function (serviceUrl) {
          let url = serviceUrl + '/alerts/' + self.currentId;
          WebResourceSecure.getJSON(url).then(function (alert) {
            try {
              self.alert = alert;
              AssuranceAlertService.updateAlertDefinition(self.alert, self.metadata);

              // console.log(JSON.stringify(alert));
              self.status = alert.status || '';
              self.statusDef = alert.statusDef || {};

              function toKey(group) {
                // group looks like [ [ 'key1', 'value1' ], [ 'key2', 'value2' ], [ 'key3', 'value3' ] ]
                return _.sortBy(group, [g => g[0], g => g[1]]).map(g => g[1]).join('\u241E');
              }

              self.groupStatuses = self.statusDef.group_statuses
                  ? AssuranceAlertService.updateAlertStatuses(self.statusDef.group_statuses.map(g => {
                    return {
                      key: toKey(g.group),
                      group: g.group,
                      status: g.status,
                      last_updated: g.last_updated
                    }
                  })) : [];


              self.currentTitle = alert.name || UNTITLED;
              self.currentCategory = alert.category;
              self.currentType = alert.category.startsWith(EVENT) ? EVENT : 'metric';
              if (self.isEvent) self.setupEventFilter();
              // update metrics list
              self.handleCategoryChange();
              self.currentMetric = alert.metric;
              self.handleMetricChange();
              self.currentFilterRSQL = alert.condition;

              if (!_.isEmpty(alert.selectedItems)) {
                self.translatedSelections = _.map(_.toPairs(alert.selectedItems), function (a) {
                  return {id: a[0], name: a[1]}
                });
              }

              if (alert.display && alert.display.filterModel) { // prefer filterModel over parsing currentFilterRSQL
                if (self.isEvent) {
                  self.currentEventsFilterModel = alert.display.filterModel;
                } else {
                  self.currentFilterModel = alert.display.filterModel;
                  // migrate auto filter
                  if (self.currentFilterModel.filterGroups.length > 0 && self.currentFilterModel.filterGroups[0].filters.length > 0
                      && self.currentFilterModel.filterGroups[0].filters[0].auto && !self.currentFilterModel.filterGroups[0].filters[0].isQuickPick) {
                    self.currentFilterModel.filterGroups[0].filters[0] = buildFilterFromSelections(self);
                  }
                }
              } else if (self.selectedCategoryMetadata && self.currentFilterRSQL) {
                let filterExpression = FilterExpressionService.getFiltersFromString(self.currentFilterRSQL,
                    FilterExpressionService.getFilterOptionsForMetric(self.selectedCategoryMetadata.filterOptions, self.selectedMetricMetadata));

                // swap out the proper =in= filter for the one we replaced in parsing
                if (!_.isEmpty(alert.selectedItems) && filterExpression.filterGroups[0] && filterExpression.filterGroups[0].filters[0]) {
                  filterExpression.filterGroups[0].filters[0] = buildFilterFromSelections(self); // todo make this more generic to look for the right one to replace tags=="{id}=-515"
                  self.updateCurrentFilterDescription();
                }

                // todo I'm not sure if filterExpression.filterGroups is dynamic
                self.currentFilterModel = {
                  filterGroups: filterExpression.filterGroups || [{
                    filters: [],
                    operator: 'and'
                  }], operator: filterExpression.operator || 'and'
                };
              }

              // todo move into setupEventFilter
              if (self.isEvent && alert.display && alert.display.sourceFilters && alert.display.sourceFilters.length > 0) {
                // todo support multiple source filters
                self.currentEventSource = alert.display.sourceFilters[0].type;
                self.currentEventSourceFilterModel = alert.display.sourceFilters[0].filterModel;
              }

              if (alert.display && alert.display.qualityFilters) {
                self.qualityFilters = alert.display.qualityFilters;
              }

              self.duration = alert.duration === 0 ? 0 : Math.ceil(alert.duration / 60);
              self.currentFilterDescription = alert.description;
              self.window = alert.lookbackDuration === 0 ? 0 : Math.ceil(alert.lookbackDuration / 60 / 60);
              self.enabled = alert.enabled;
              self.operation = alert.operation;
              if (alert.groupBy) {
                if (self.isEvent) {
                  self.currentGroupBy = 'source_type,source_id,event_type,event_level,start_time,unique_message'.split(','); // this is also hard coded in alert configuration service
                } else {
                  self.currentGroupBy = alert.groupBy.split(',');
                }
                self.handleGroupByChange(); // need to migrate operation before setting oldOperation
              }
              self.oldOperation = self.operation;

              self.triggers = [];

              function setupNotifications(from, key, to) {
                if (from) {
                  to.threshold = from.value;
                  if (from.value) {
                    self.triggers.push({
                      id: UtilsService.generateID(),
                      selectedStatus: key,
                      threshold: from.value,
                    });
                  }
                  if (from.notifications && from.notifications.length > 0) {
                    to.notifications = _.map(from.notifications,
                        a => {
                          return {
                            uid: UtilsService.generateID(),
                            enabled: a.enabled,
                            action: a.action,
                            recipients: _.map(a.recipients, r => r.address).join(','),
                            recipientsDisplay: _.map(a.recipients, r => r.address + (r.status === 'BOUNCED' ? ' (bounced)' : '')).join(','),
                            name: a.subject || '',
                            format: a.format,
                            frequency: 'once',
                            customText: a.message_body,
                            scheduleDays: a.active_days,
                            scheduleStartTime: a.active_start_time,
                            scheduleEndTime: a.active_end_time,
                            timeZone: a.time_zone,
                            timeZoneAbr: moment().tz(a.time_zone).zoneAbbr(),
                          };
                        })
                  }
                }
              }

              setupNotifications(alert.error, 'ERROR', self.conditionsAndNotificationItems.critical);
              setupNotifications(alert.warn, 'WARN', self.conditionsAndNotificationItems.warn);
              setupNotifications(alert.info, 'INFO', self.conditionsAndNotificationItems.info);


              self.dynamicFilter = self.dangerOnSelect;
              self.$nextTick(() => self.loading = false);
            } catch (e) {
              console.log(e);
              let width = e.stack.length < 150 ? 640 : '75cqw';
              self.$refs.infoLoad.open('Load Error', '<p>There was an error loading this monitor.</p><pre style="max-height: calc(75vh - 235px);min-height: 40px;">' + e.stack + '</pre>', {
                color: 'var(--bad-color)',
                width: width
              }).then(function () {
                if (DataProvider.getInstance().isInternalUser()) {
                  self.$refs.confirmLoadErrorDelete.open(`Delete Bad Monitor`,
                      `<p>If this monitor configuration is broken (as an internal user) you can delete it.</p>Do you want to delete this monitor?`,
                      {color: 'var(--fair-color)'}).then((confirm) => {
                    if (confirm) {
                      self.invokeDelete(true);
                    } else {
                      self.onCancel();
                    }
                  });
                } else {
                  self.onCancel();
                }
              });
            }
          }).catch(e => {
            console.log(e);
            let width = e.length < 150 ? 640 : '75cqw';
            self.$refs.infoLoad.open('Load Error', '<p>There was an error loading this monitor.</p><pre style="max-height: calc(75vh - 235px);min-height: 40px;">' + e + '</pre>', {
              color: 'var(--bad-color)',
              width: width
            }).then(() => {self.onCancel();});
          });
        });
      },
      setupEventFilter: function() {
        let self = this;
        let eventDatasetMetadata = self.datasetMetadata.find(config => config.id.toLowerCase() === 'events');
        
        // todo handle passing in 
        self.currentEventsFilterModel = { filterGroups: VueDatasetService.getQuickStartFilterGroups('events', eventDatasetMetadata), operator: 'and' }; // todo handle passing in 

        let columns = eventDatasetMetadata.columns;

        let filteredColumns = columns.filter(column => !column.invisible);
        let filterOptions = dvFilterService.getColumnOptions(filteredColumns);
        self.eventFilterColumns = FilterExpressionService.getColumnsFromFilters(filterOptions);
        
        self.setupEventSourceFilter('endpoints'); // todo don't hard code this
        self.updateCurrentFilterDescription();
      },
      setupEventSourceFilter: function (source) {
        let self = this;

        self.currentEventSource = source;
                
        self.eventSourceDatasetMetadata = self.datasetMetadata.find(config => config.id.toLowerCase() === source);

        // todo handle passing in 
        self.currentFilterRSQL = '';
        self.currentEventSourceFilterModel = { filterGroups: VueDatasetService.getQuickStartFilterGroups(source + '-events', self.eventSourceDatasetMetadata), operator: 'and' };

        let columns = self.eventSourceDatasetMetadata.columns;

        let filteredColumns = columns.filter(column => !column.invisible);
        let filterOptions = dvFilterService.getColumnOptions(filteredColumns);
        self.eventSourceFilterColumns = FilterExpressionService.getColumnsFromFilters(filterOptions);
      },
      onEventsFilterChange: function(filterGroups) {
        let self = this;
        self.currentEventsFilterModel.filterGroups = filterGroups;
        self.updateEventFilter();
      },
      onEventsFilterOperatorChange: function(operator) {
        let self = this;
        self.currentEventsFilterModel.operator = operator;
        self.updateEventFilter();
      },
      onEventSourceFilterChange: function(filterGroups) {
        let self = this;
        self.currentEventSourceFilterModel.filterGroups = filterGroups;
        self.updateEventFilter();
      },
      onEventSourceFilterOperatorChange: function(operator) {
        let self = this;
        self.currentEventSourceFilterModel.operator = operator;
        self.updateEventFilter();
      },
      taFocus: function(notification) {
        let ta = this.$refs['ta-'+notification.uid][0].$el.querySelector('textarea');
        this.$nextTick(() => ta.focus({preventScroll:true}));
      },
      insertVariable: function(notification, key) {
        let ta = this.$refs['ta-'+notification.uid][0].$el.querySelector('textarea');
        let positionStart = ta.selectionStart || 0;
        let positionEnd = ta.selectionEnd || positionStart;
        let a = notification.customText;
        let insert = ['[(${', key, '})]'].join('');
        notification.customText = [a.slice(0, positionStart), insert, a.slice(positionEnd)].join('');
        ta.focus({preventScroll:true});
        this.$nextTick(() => ta.selectionStart = ta.selectionEnd = positionStart + insert.length);
      },
      insertSample: function(notification, key) {
        let ta = this.$refs['ta-'+notification.uid][0].$el.querySelector('textarea');
        let positionStart = ta.selectionStart || 0;
        let positionEnd = ta.selectionEnd || positionStart;
        let a = notification.customText;
        notification.customText = [a.slice(0, positionStart), key, a.slice(positionEnd)].join('');
        ta.focus({preventScroll:true});
        this.$nextTick(() => ta.selectionStart = ta.selectionEnd = positionStart + key.length);
      },
      enabledCount: function(notifications) {
        return _.filter(notifications, 'enabled').length;
      },
      notificationIcon: function(type) {
        if (type) {
          switch(type.toUpperCase()) {
            case 'EMAIL': return 'fa-fw fas fa-envelope';
            case 'WEBHOOK': return 'fa-fw fas fa-globe'
          }
        }
        return 'fa-fw fal fa-envelope';
      },
      statusToIcon: function(s) {
        if (s) {
          switch(s.toLowerCase()) {
            case 'clear':
            case 'ok': return 'alert-state-ok fas fa-check-circle';
            case 'info':
            case 'important': return 'alert-state-info fas fa-info-circle';
            case 'warn': return 'alert-state-warn fas fa-exclamation-square';
            case 'critical':
            case 'error': return 'alert-state-error fas fa-exclamation-triangle';
          }
        }
        return 'alert-state-unknown fas fa-question-circle';
      },

      statusToCondition: function (s) {
        let self = this;
        return _.find(self.statuses, {value: s}).extra.condition;
      }, 
      
      statusToClass: function(s) {
        let self = this;
        return this.statusToCondition(s).class;
      },

      statusToThresholdFieldClass: function(s) {
        let self = this;
        return this.statusToCondition(s).thresholdFieldClass;
      },

      daySelected: function (day, scheduleDays) {
        return _.includes(scheduleDays, day) ? 'selected-day' : '';
      },

      daySelectedBoolean: function (day, scheduleDays) {
        return _.includes(scheduleDays, day);
      },

      updateCurrentFilterDescription: function () {
        let self = this;
        if (self.isEvent) {
          self.currentFilterDescription = self.currentEventsFilterModel && self.currentEventsFilterModel.filterGroups && self.currentEventsFilterModel.filterGroups.length > 0
              ? FilterExpressionService.getFilterDisplayStringFromFilterExpression(
                  self.currentEventsFilterModel) : '';

          if (self.currentEventSourceFilterModel && self.currentEventSourceFilterModel.filterGroups && self.currentEventSourceFilterModel.filterGroups.length > 0) {
            let sourceFilter = FilterExpressionService.getFilterDisplayStringFromFilterExpression(self.currentEventSourceFilterModel);
            if (sourceFilter) {
              self.currentFilterDescription = '( ' + self.currentFilterDescription + ' ) and ( ' + sourceFilter + ' )';
            }
          }
        } else {
          self.currentFilterDescription = self.currentFilterModel && self.currentFilterModel.filterGroups && self.currentFilterModel.filterGroups.length > 0
              ? FilterExpressionService.getFilterDisplayStringFromFilterExpression(
                  self.currentFilterModel) : '';
        }        
      },

      updateCurrentFilterFromSelection: function (updateFilterStrings) {
        let self = this;
        self.qualityFilters = undefined;

        if (updateFilterStrings) {
          self.currentFilterRSQL = self.currentFilterModel && self.currentFilterModel.filterGroups && self.currentFilterModel.filterGroups.length > 0
              ? FilterExpressionService.getFilterStringFromFilterExpression(self.currentFilterModel, true)
              : '';
          self.updateCurrentFilterDescription();
        }
      },

      doNothing: function() {

      },
      getFrequencyDisplayName: function(frequency) {
        let self = this;
        // return _.get(_.find(self.frequencies, v => v.value === _.lowerCase(frequency)), 'text', '');
        return 'Once per state change';
      },
      titleClick: function() {
        let self = this;
        if (self.currentTitle === UNTITLED) {
          self.$refs.titleTextField.$el.querySelector('input').select();
        }
      },
      validateThresholdInput: function() {
        let self = this;
        self.thresholdError = !self.anyThresholdsFilledIn && !self.thresholdsOrdered;
      },
      isShortInteger: function(evt, current) {
        if ((''+current).length > 4) {
          evt.preventDefault();
        } else {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
            evt.preventDefault();
          } else {
            return true;
          }
        }
      },
      isTripleInteger: function(evt, current) {
        if ((''+current).length > 2) {
          evt.preventDefault();
        } else if ((''+current).length > 1 && (''+current)[0] !== '1') {
          evt.preventDefault();
        } else {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
            evt.preventDefault();
          } else {
            return true;
          }
        }
      },
      isSingleInteger: function(evt, current) {
        if ((''+current).length > 0) {
          evt.preventDefault();
        } else {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
            evt.preventDefault();
          } else {
            return true;
          }
        }
      },
      updateEndtime: function(newTime, notification) {
        let self = this;
        notification.scheduleEndTime = (newTime.hours < 10 ? '0': '' ) + newTime.hours + ':' + (newTime.minutes < 10 ? '0': '' ) + newTime.minutes;
      },
      updateStarttime: function(newTime, notification) {
        let self = this;
        notification.scheduleStartTime = (newTime.hours < 10 ? '0': '' ) + newTime.hours + ':' + (newTime.minutes < 10 ? '0': '' ) + newTime.minutes;
      },
      getSystemImageUrl: function(type) {
        let self = this;
        return ImageService.getSystemImageUrl(type) + '?bust=' + GLOBAL_VERSION;
      },

      handleCategoryChange: function() {
        let self = this;
        // clear things
        self.currentMetric = '';
        // clear filter and selected items
        self.selectedMetricMetadata = null;
        self.selectedGroupByMetadata = null;
        self.qualityFilters = undefined;
        self.currentFilterRSQL = '';
        self.currentFilterModel = getEmptyFilterExpression();
        self.currentFilterDescription = '';
        self.translatedSelections = [];


        self.selectedCategoryMetadata = _.find(self.metadata, function (item) {
          return item.id === self.currentCategory;
        });

        self.currentGroupBy = [];
        self.groupBys = [];
        self.groupBySimpleTooltip = 'group';

        let categoryMetricsMetadata = _.get(self.selectedCategoryMetadata, 'metrics');
        let metricsList = getDropdownOptions(_.filter(categoryMetricsMetadata, o => !_.get(o, 'deprecated', false)));
        if (metricsList.length > 0) metricsList.unshift({header:'Summary Metrics'});
        let deprecatedMetricsList = getDropdownOptions(_.filter(categoryMetricsMetadata, ['deprecated',true]));
        if (deprecatedMetricsList.length > 0) {
          metricsList.push({header:'Legacy Summary Metrics'});
          metricsList.push(...deprecatedMetricsList);
        }
        self.availableMetricsMetadata = categoryMetricsMetadata ? [...categoryMetricsMetadata] : [];


        // the api keys are always plural so make sure we add a 's' to things
        var modelKey = 'models.' + self.currentCategory;
        if (!_.endsWith(modelKey, 's')) {
          modelKey += 's';
        }
        self.modelList = _.get(self.modelsMetaData, modelKey);

        var modelMetaData = _.get(self.selectedCategoryMetadata, 'models');

        // filter model metadata based on modelList ids
        var filteredModelMetadata = _.filter(modelMetaData, function (o) {
          return _.includes(self.modelList, o.id);
        });

        self.systemMetrics = {};
        _.forEach(filteredModelMetadata, model => {
          _.forEach(_.get(model, 'metrics'), metric => {
            if (self.systemMetrics[metric.id]) {
              self.systemMetrics[metric.id].models.push({ id: model.id, name: model.name })
            } else {
              self.systemMetrics[metric.id] = _.assign({ models: [{ id: model.id, name: model.name }] }, metric);
            }
          });
        })
        let values = _.values(self.systemMetrics);
        if (values.length > 0) {

          let systemMetricsList = getDropdownOptions(values);
          systemMetricsList = _.sortBy(systemMetricsList, 'text'); // sort alphabetically

          systemMetricsList.unshift({header:'System Metrics'});
          metricsList.push(...systemMetricsList);

          self.availableMetricsMetadata.push(...values);
        }
        self.metrics = metricsList;

        self.currentFilterRSQL = '';
        self.currentFilterModel = { filterGroups: VueDatasetService.getQuickStartFilterGroups(self.currentCategory + '-monitors', self.selectedCategoryMetadata), operator: 'and' };
        self.currentFilterDescriptioncurrentFilterDescription = '';

      },

      handleGroupByChange: function() {
        let self = this;
        
        if (self.isEvent) {
          let eventDatasetMetadata = self.datasetMetadata.find(config => config.id.toLowerCase() === 'events');
          let columns = eventDatasetMetadata.columns;
          let filteredColumns = columns.filter(column => !column.invisible || column.includeAlertGroupBy);

          self.groupBys = getGroupByOptions(filteredColumns);
          self.groupBySimpleTooltip = getGroupBySimpleToolTip(filteredColumns);
        }

        // migrate old operator and value to handle alerts created in beta
        if (self.uniqueThreshold) {
          if (self.operation === 'gte') { // Exists
            self.operation = 'gt';
            _.forEach(self.conditionsAndNotificationItems, c => {
              if (c.threshold === '1') {
                c.threshold = '0';
              }
            })
          } else if (self.operation === 'lt') { // Does Not Exist
            self.operation = 'eq';
            _.forEach(self.conditionsAndNotificationItems, c => {
              if (c.threshold === '1') {
                c.threshold = '0';
              }
            })
          }
        }
        
        if (self.currentGroupBy.length === 1 && self.selectedCategoryMetadata) {
          var selectedGroupByMetadata = _.find(self.selectedCategoryMetadata.filterOptions, function (item) {
            return item.id === self.currentGroupBy[0] && !_.get(item, 'excludeAlertGroupBy');
          });
          if (selectedGroupByMetadata) {
            self.currentGroupByColors = _.get(selectedGroupByMetadata,'colors', {});
          } else {
            self.currentGroupByColors = {};
          }
        } else {
          self.currentGroupByColors = {};
        }

        self.currentGroupByDisplay = _.map(self.currentGroupBy, gb => _.get(_.find(self.groupBys, { 'value' : gb}), 'text') );
      },

      handleMetricChange: function() {
        let self = this;
        self.selectedMetricMetadata =
            _.find(self.availableMetricsMetadata, function (metric) {
              return metric.id === self.currentMetric;
            });

        if (self.selectedCategoryMetadata) {
          let filterOptionsForMetric = FilterExpressionService.getFilterOptionsForMetric(self.selectedCategoryMetadata.filterOptions, self.selectedMetricMetadata);
          self.filterColumns = FilterExpressionService.getColumnsFromFilters(filterOptionsForMetric).filter(column => !column.invisible);
          // todo do I need to reset - it would be nice to keep this if the group bys exist in the new metadata
          self.currentGroupBy = [];
          self.groupBys = getGroupByOptions(FilterExpressionService.getFilterOptionsForMetric(self.selectedCategoryMetadata.filterOptions, self.selectedMetricMetadata, false));
          self.groupBySimpleTooltip = getGroupBySimpleToolTip(FilterExpressionService.getFilterOptionsForMetric(self.selectedCategoryMetadata.filterOptions, self.selectedMetricMetadata, false));
        } else {
          self.currentGroupBy = [];
          self.groupBys = [];
          self.groupBySimpleTooltip = 'group';
        }
        self.qualityFilters = undefined;

        self.updateCurrentFilterFromSelection(true)
      },

      updateValidStatus: function(trigger) {
        self.currentlySelectedTrigger = trigger;
      },
      
      handleSelectedStatusChange: function(trigger) {
        let self = this;
        // clear all existing thresholds
        _.forEach(self.conditionsAndNotificationItems, v => v.threshold = '');
        // apply threshold to new status
        _.forEach(self.triggers, t => self.handleThresholdChange(t));
      },
      
      handleThresholdChange: function(trigger) {
        let self = this;
        self.statusToCondition(trigger.selectedStatus).threshold = trigger.threshold;
      },
      
      handleOperationChange: function(a) {
        let self = this;

        let criticalTrigger = _.find(self.triggers, {selectedStatus:'ERROR'});
        let warnTrigger = _.find(self.triggers, {selectedStatus:'WARN'});
        let infoTrigger = _.find(self.triggers, {selectedStatus:'INFO'});

        // body swap
        if (self.oldOperation && self.oldOperation !== self.operation) {
          if ((self.oldOperation === 'lt' || self.oldOperation === 'lte') &&
              (self.operation === 'gt' || self.operation === 'gte')) {
            if (self.conditionsAndNotificationItems.critical.threshold
                && self.conditionsAndNotificationItems.warn.threshold
                && self.conditionsAndNotificationItems.info.threshold
                && parseInt(self.conditionsAndNotificationItems.critical.threshold) < parseInt(self.conditionsAndNotificationItems.info.threshold)) {
              let swap = self.conditionsAndNotificationItems.critical.threshold;
              criticalTrigger.threshold = self.conditionsAndNotificationItems.info.threshold;
              infoTrigger.threshold = swap;
              self.handleThresholdChange(criticalTrigger);
              self.handleThresholdChange(infoTrigger);
            } else if (self.conditionsAndNotificationItems.critical.threshold
                && self.conditionsAndNotificationItems.warn.threshold
                && parseInt(self.conditionsAndNotificationItems.critical.threshold) < parseInt(self.conditionsAndNotificationItems.warn.threshold)) {
              let swap = self.conditionsAndNotificationItems.critical.threshold;
              criticalTrigger.threshold = self.conditionsAndNotificationItems.warn.threshold;
              warnTrigger.threshold = swap;
              self.handleThresholdChange(criticalTrigger);
              self.handleThresholdChange(warnTrigger);
            } else if (self.conditionsAndNotificationItems.critical.threshold
                && self.conditionsAndNotificationItems.info.threshold
                && parseInt(self.conditionsAndNotificationItems.critical.threshold) < parseInt(self.conditionsAndNotificationItems.info.threshold)) {
              let swap = self.conditionsAndNotificationItems.critical.threshold;
              criticalTrigger.threshold = self.conditionsAndNotificationItems.info.threshold;
              infoTrigger.threshold = swap;
              self.handleThresholdChange(criticalTrigger);
              self.handleThresholdChange(infoTrigger);
            } else if (self.conditionsAndNotificationItems.warn.threshold
                && self.conditionsAndNotificationItems.info.threshold
                && parseInt(self.conditionsAndNotificationItems.warn.threshold) < parseInt(self.conditionsAndNotificationItems.info.threshold)) {
              let swap = self.conditionsAndNotificationItems.warn.threshold;
              warnTrigger.threshold = self.conditionsAndNotificationItems.info.threshold;
              infoTrigger.threshold = swap;
              self.handleThresholdChange(warnTrigger);
              self.handleThresholdChange(infoTrigger);
            }
          } else if ((self.oldOperation === 'gt' || self.oldOperation === 'gte') &&
                  (self.operation === 'lt' || self.operation === 'lte')) {
            if (self.conditionsAndNotificationItems.critical.threshold
                && self.conditionsAndNotificationItems.warn.threshold
                && self.conditionsAndNotificationItems.info.threshold
                && parseInt(self.conditionsAndNotificationItems.critical.threshold) > parseInt(self.conditionsAndNotificationItems.info.threshold)) {
              let swap = self.conditionsAndNotificationItems.critical.threshold;
              criticalTrigger.threshold = self.conditionsAndNotificationItems.info.threshold;
              infoTrigger.threshold = swap;
              self.handleThresholdChange(criticalTrigger);
              self.handleThresholdChange(infoTrigger);
            } else if (self.conditionsAndNotificationItems.critical.threshold
                && self.conditionsAndNotificationItems.warn.threshold
                && parseInt(self.conditionsAndNotificationItems.critical.threshold) > parseInt(self.conditionsAndNotificationItems.warn.threshold)) {
              let swap = self.conditionsAndNotificationItems.critical.threshold;
              criticalTrigger.threshold = self.conditionsAndNotificationItems.warn.threshold;
              warnTrigger.threshold = swap;
              self.handleThresholdChange(criticalTrigger);
              self.handleThresholdChange(warnTrigger);
            } else if (self.conditionsAndNotificationItems.critical.threshold
                && self.conditionsAndNotificationItems.info.threshold
                && parseInt(self.conditionsAndNotificationItems.critical.threshold) > parseInt(self.conditionsAndNotificationItems.info.threshold)) {
              let swap = self.conditionsAndNotificationItems.critical.threshold;
              criticalTrigger.threshold = self.conditionsAndNotificationItems.info.threshold;
              infoTrigger.threshold = swap;
              self.handleThresholdChange(criticalTrigger);
              self.handleThresholdChange(infoTrigger);
            } else if (self.conditionsAndNotificationItems.warn.threshold
                && self.conditionsAndNotificationItems.info.threshold
                && parseInt(self.conditionsAndNotificationItems.warn.threshold) > parseInt(self.conditionsAndNotificationItems.info.threshold)) {
              let swap = self.conditionsAndNotificationItems.warn.threshold;
              warnTrigger.threshold = self.conditionsAndNotificationItems.info.threshold;
              infoTrigger.threshold = swap;
              self.handleThresholdChange(warnTrigger);
              self.handleThresholdChange(infoTrigger);
            }
          } else if (((self.oldOperation === 'ne' || self.oldOperation === 'eq') &&
              (self.operation === 'gt' || self.operation === 'gte'))){
            if (self.conditionsAndNotificationItems.critical.threshold
                && self.conditionsAndNotificationItems.warn.threshold
                && self.conditionsAndNotificationItems.info.threshold
                && parseInt(self.conditionsAndNotificationItems.critical.threshold) < parseInt(self.conditionsAndNotificationItems.info.threshold)) {
              let swap = self.conditionsAndNotificationItems.critical.threshold;
              criticalTrigger.threshold = self.conditionsAndNotificationItems.info.threshold;
              infoTrigger.threshold = swap;
              self.handleThresholdChange(criticalTrigger);
              self.handleThresholdChange(infoTrigger);
            } else if (self.conditionsAndNotificationItems.critical.threshold
                && self.conditionsAndNotificationItems.warn.threshold
                && parseInt(self.conditionsAndNotificationItems.critical.threshold) < parseInt(self.conditionsAndNotificationItems.warn.threshold)) {
              let swap = self.conditionsAndNotificationItems.critical.threshold;
              criticalTrigger.threshold = self.conditionsAndNotificationItems.warn.threshold;
              warnTrigger.threshold = swap;
              self.handleThresholdChange(criticalTrigger);
              self.handleThresholdChange(warnTrigger);
            } else if (self.conditionsAndNotificationItems.critical.threshold
                && self.conditionsAndNotificationItems.info.threshold
                && parseInt(self.conditionsAndNotificationItems.critical.threshold) < parseInt(self.conditionsAndNotificationItems.info.threshold)) {
              let swap = self.conditionsAndNotificationItems.critical.threshold;
              criticalTrigger.threshold = self.conditionsAndNotificationItems.info.threshold;
              infoTrigger.threshold = swap;
              self.handleThresholdChange(criticalTrigger);
              self.handleThresholdChange(infoTrigger);
            } else if (self.conditionsAndNotificationItems.warn.threshold
                && self.conditionsAndNotificationItems.info.threshold
                && parseInt(self.conditionsAndNotificationItems.warn.threshold) < parseInt(self.conditionsAndNotificationItems.info.threshold)) {
              let swap = self.conditionsAndNotificationItems.warn.threshold;
              warnTrigger.threshold = self.conditionsAndNotificationItems.info.threshold;
              infoTrigger.threshold = swap;
              self.handleThresholdChange(warnTrigger);
              self.handleThresholdChange(infoTrigger);
            }
          } else if (((self.oldOperation === 'ne' || self.oldOperation === 'eq') &&
              (self.operation === 'lt' || self.operation === 'lte'))){
            if (self.conditionsAndNotificationItems.critical.threshold
                && self.conditionsAndNotificationItems.warn.threshold
                && self.conditionsAndNotificationItems.info.threshold
                && parseInt(self.conditionsAndNotificationItems.critical.threshold) > parseInt(self.conditionsAndNotificationItems.info.threshold)) {
              let swap = self.conditionsAndNotificationItems.critical.threshold;
              criticalTrigger.threshold = self.conditionsAndNotificationItems.info.threshold;
              infoTrigger.threshold = swap;
              self.handleThresholdChange(criticalTrigger);
              self.handleThresholdChange(infoTrigger);
            } else if (self.conditionsAndNotificationItems.critical.threshold
                && self.conditionsAndNotificationItems.warn.threshold
                && parseInt(self.conditionsAndNotificationItems.critical.threshold) > parseInt(self.conditionsAndNotificationItems.warn.threshold)) {
              let swap = self.conditionsAndNotificationItems.critical.threshold;
              criticalTrigger.threshold = self.conditionsAndNotificationItems.warn.threshold;
              warnTrigger.threshold = swap;
              self.handleThresholdChange(criticalTrigger);
              self.handleThresholdChange(warnTrigger);
            } else if (self.conditionsAndNotificationItems.critical.threshold
                && self.conditionsAndNotificationItems.info.threshold
                && parseInt(self.conditionsAndNotificationItems.critical.threshold) > parseInt(self.conditionsAndNotificationItems.info.threshold)) {
              let swap = self.conditionsAndNotificationItems.critical.threshold;
              criticalTrigger.threshold = self.conditionsAndNotificationItems.info.threshold;
              infoTrigger.threshold = swap;
              self.handleThresholdChange(criticalTrigger);
              self.handleThresholdChange(infoTrigger);
            } else if (self.conditionsAndNotificationItems.warn.threshold
                && self.conditionsAndNotificationItems.info.threshold
                && parseInt(self.conditionsAndNotificationItems.warn.threshold) > parseInt(self.conditionsAndNotificationItems.info.threshold)) {
              let swap = self.conditionsAndNotificationItems.warn.threshold;
              warnTrigger.threshold = self.conditionsAndNotificationItems.info.threshold;
              infoTrigger.threshold = swap;
              self.handleThresholdChange(warnTrigger);
              self.handleThresholdChange(infoTrigger);
            }
          }
        }
        self.oldOperation = self.operation;
      },

      onEdit() {
        let self = this;
        window.location.href = '#monitoring/moi/' + self.currentId + '?edit';
      },

      onDelete() {
        let self = this;

        self.$refs.confirmDelete.open('Delete', 'Are you sure you want to delete this Monitor?', { color: 'var(--bad-color)' }).then((confirm) => {
          if (confirm) {
            return self.invokeDelete(false);
          }
        });
      },

      invokeDelete(forceDelete) {
        let self = this;

        function deleteMonitor(force) {
          //todo put up modal to wait for delete to complete as it's async
          self.deleting = true;
          return DataProvider.getInstance().fetchAssuranceAlertConfigServiceBaseURL()
          .then(function (baseUrl) {
            let method = 'DELETE';
            let url = baseUrl + '/alerts/' + self.currentId;
            return WebResourceSecure.getJSON(url, undefined, method, 'text')
            .then(function () {
              window.location.hash = '#monitoring/moi';
            })
            .catch(function (error) {
              // todo show error
              console.log(error);
              if (force) {
                window.location.hash = '#monitoring/moi';
              }
            });
          });
        }

        return deleteMonitor(forceDelete);
      },

      gotoNext: function (savedId, dontWait) {
        let self = this;
        let href = '#monitoring/moi'; // todo should new go to view page?
        if (self.next) {
          href = '#' + self.next;
        } else if (savedId) {
          href = '#monitoring/moi/' + savedId;
        }

        self.saving = false;
        window.location.href = href;
      },

      onCancel() {
        let self = this;
        if (self.$refs.alertChart) self.$refs.alertChart.hideTooltip();
        // todo check if changes have been made and will be lost and prompt user before canceling/closing
        if (self.isViewMode) {
          self.gotoNext();
        } else {
          self.gotoNext(self.isNew ? '' : self.currentId, true);
        }
      },

      onSave() {
        let self = this;
        // delay till all the form elements complete editing (e.g. open filter IN combo select) - I wish there was a better way to enforce this 
        setTimeout(() => {
          self.lastModified = moment().valueOf();
          return DataProvider.getInstance().fetchAssuranceAlertConfigServiceBaseURL().then(function (baseUrl) {
            let method = 'POST';
            let url = baseUrl + '/alerts';
            if (!self.isNew) {
              method = 'PUT'
              url += '/' + self.currentId;
            }
  
  
            function doSave() {
              // if (self.dynamicFilter) {
              //   selectedItems = null;
              // } else {
              //   updateCurrentFilterFromSelection(self);
              // }
  
              self.saving = true;
  
              function mapNotification(notification) {
                return {
                  action: notification.action,
                  enabled: notification.enabled,
                  recipients: _.filter(
                      _.map(notification.recipients.split(','),
                          function (addr) {
                            return {address: addr.trim()}
                          }), f => !_.isEmpty(f.address)),
                  subject: notification.name,
                  format: notification.format,
                  frequency: 'ONCE',
                  message_body: notification.customText,
                  active_days: notification.scheduleDays,
                  active_start_time: notification.scheduleStartTime,
                  active_end_time: notification.scheduleEndTime,
                  time_zone: notification.timeZone
                }
              }
  
              let selectedItems = _.fromPairs(_.map(self.translatedSelections, function (o) {
                return _.values(o)
              }));
              let condition = self.currentFilterRSQL;
              let description = self.currentFilterDescription;
  
              let payload = self.isEvent
                  ? {
                    name: self.currentTitle,
                    condition: condition, // only used to compare to determing if status groups need to be cleared
                    groupBy: self.currentGroupBy.join(','),
                    category: EVENT,
                    duration: self.duration * 60,
                    description: description,
                    lookbackDuration: self.window * 60 * 60,
                    enabled: self.enabled,
                    operation: self.operation,
                    selectedItems: selectedItems,
                    display: {
                      category: 'Events',
                      groupBy: self.currentGroupByDisplay ? self.currentGroupByDisplay.join(', ') : '',
                      filterModel: self.currentEventsFilterModel,
                      sourceFilters: [
                        {
                          type: self.currentEventSource,
                          filterModel: self.currentEventSourceFilterModel
                        }
                      ],
                      data: {
                        eventFilters: FilterMigrationService.migrateFilterExpressionToApiFilter(self.currentEventsFilterModel),
                        sourceFilters: [
                          {
                            type: self.currentEventSource,
                            filters: FilterMigrationService.migrateFilterExpressionToApiFilter(self.currentEventSourceFilterModel)
                          }
                        ],
                      }
                    },
                    error: {
                      value: self.conditionsAndNotificationItems.critical.threshold,
                      notifications: _.map(self.conditionsAndNotificationItems.critical.notifications, n => mapNotification(n)),
                    },
                    warn: {
                      value: self.conditionsAndNotificationItems.warn.threshold,
                      notifications: _.map(self.conditionsAndNotificationItems.warn.notifications, n => mapNotification(n)),
                    },
                    info: {
                      value: self.conditionsAndNotificationItems.info.threshold,
                      notifications: _.map(self.conditionsAndNotificationItems.info.notifications, n => mapNotification(n)),
                    }
                  }
                  : {
                    name: self.currentTitle,
                    category: self.currentCategory,
                    metric: self.currentMetric,
                    groupBy: self.currentGroupBy.join(','),
                    condition: condition,
                    duration: self.duration * 60,
                    description: description,
                    lookbackDuration: self.window * 60 * 60,
                    enabled: self.enabled,
                    operation: self.operation,
                    selectedItems: selectedItems,
                    display: {
                      category: self.selectedCategoryMetadata.name,
                      metric: self.selectedMetricMetadata.name,
                      groupBy: self.currentGroupByDisplay ? self.currentGroupByDisplay.join(', ') : '',
                      filterModel: self.currentFilterModel,
                      // data: {
                      //   metricFilters: FilterMigrationService.migrateFilterExpressionToApiFilter(self.currentFilterModel),
                      //   qualityFilters: FilterMigrationService.migrateFilterExpressionToApiFilter(self.qualityFilters), // todo
                      // },
                      qualityFilters: self.qualityFilters,
                    },
                    error: {
                      value: self.conditionsAndNotificationItems.critical.threshold,
                      notifications: _.map(self.conditionsAndNotificationItems.critical.notifications, n => mapNotification(n)),
                    },
                    warn: {
                      value: self.conditionsAndNotificationItems.warn.threshold,
                      notifications: _.map(self.conditionsAndNotificationItems.warn.notifications, n => mapNotification(n)),
                    },
                    info: {
                      value: self.conditionsAndNotificationItems.info.threshold,
                      notifications: _.map(self.conditionsAndNotificationItems.info.notifications, n => mapNotification(n)),
                    }
                  };
  
              // console.log(JSON.stringify(payload));
              return WebResourceSecure.getJSON(url, payload, method, 'text')
                .then(function (results) {
                  // console.log('success save');
                  // console.log(results);
                  self.gotoNext(self.isNew ? results : self.currentId, true);
                })
                .catch(function (error) {
                  // todo show error
                  self.saving = false;
  
                  console.log(error);
                  let msg = error;
                  // try {
                  //   msg = JSON.stringify(JSON.parse(results.responseText), undefined, 4);
                  // } catch(e) {
                  // }

                  let width = msg.length < 150 ? 640 : '75cqw';
                  self.$refs.infoSave.open('Save Error', '<p>There was an error saving this monitor.</p><pre style="max-height: calc(75vh - 235px);min-height: 40px;">' + msg + '</pre>', {
                    color: 'var(--bad-color)',
                    width: width
                  });
              });
            }
  

            return doSave();
          });
        });
      },
      onEnable() {
        let self = this;

        // if (self.isEditMode) { return; }
        if (self.isNew) { return; }

        return DataSecureService.setMonitorEnabled(self.currentId, self.enabled)
            .then(function(results) {
              // console.log('success patch');
              // console.log(results);
              if (self.isViewMode) {
                self.loadExistingAlertData();
              }

            })
            .catch(function (error) {
              // todo show error
              // todo uncheck switch without triggering click
              self.enabled = !self.enabled;
              console.log(error);
            });
      },
      onStop() {
        document.activeElement.blur();
      },

      onFilterOperatorChange: function(operator) {
        let self = this;
        self.currentFilterModel.operator = operator;
        self.updateFilter();
      },

      onFilterChange: function(filterGroups) {
        let self = this;
        self.currentFilterModel.filterGroups = filterGroups;
        self.updateFilter();
      },

      onQualityFiltersChanged: function(qualityFilters) {
        let self = this;
        self.qualityFilters = qualityFilters;
        self.updateFilter();
      },

      updateFilter: function() {
        let self = this;

        self.currentFilterRSQL = FilterExpressionService.getFilterStringFromFilterExpression(self.currentFilterModel, true);
        self.currentFilterDescription = FilterExpressionService.getFilterDisplayStringFromFilterExpression(self.currentFilterModel);

        if (self.qualityFilters) {
          let qualityFilterStr = FilterExpressionService.getFilterStringFromFilterExpression(self.qualityFilters, true);
          if (qualityFilterStr && self.currentFilterRSQL) {
            self.currentFilterRSQL = '(' + qualityFilterStr + ') and (' + self.currentFilterRSQL + ')';
            self.currentFilterDescription = '(' + FilterExpressionService.getFilterDisplayStringFromFilterExpression(self.qualityFilters) + ') and (' + self.currentFilterDescription + ')';
          } else if (qualityFilterStr) {
            self.currentFilterRSQL =  qualityFilterStr;
            self.currentFilterDescription = FilterExpressionService.getFilterDisplayStringFromFilterExpression(self.qualityFilters);
          }
        }

        // console.log(self.currentFilterRSQL);
        // console.log(self.currentFilterDescription);
      },

      updateEventFilter: function() {
        let self = this;
        self.currentFilterRSQL = self.currentEventsFilterModel && self.currentEventsFilterModel.filterGroups && self.currentEventsFilterModel.filterGroups.length > 0
            ? FilterExpressionService.getFilterStringFromFilterExpression(self.currentEventsFilterModel, true)
            : '';
        if (self.currentEventSourceFilterModel && self.currentEventSourceFilterModel.filterGroups && self.currentEventSourceFilterModel.filterGroups.length > 0) {
          if (self.currentFilterRSQL) {
            self.currentFilterRSQL += ' and ' + FilterExpressionService.getFilterStringFromFilterExpression(self.currentEventSourceFilterModel, true);
          } else {
            self.currentFilterRSQL = FilterExpressionService.getFilterStringFromFilterExpression(self.currentEventSourceFilterModel, true);
          }
        }
        self.updateCurrentFilterDescription(true);
      },
      
      onAddNotification: function(notifications, index, type) {
        let self = this;
        // todo refactor
        let email = LoginService.userObject.email;
        if ( _.startsWith(email, 'vyoptaadmin@') || (email === 'support@vyopta.com') ) {
          email = '';
        }

        switch(type.toLocaleUpperCase()) {
          case 'EMAIL':
            notifications.splice(index+1, 0, { // todo refactor
              uid: UtilsService.generateID(),
              enabled: true,
              action: type,
              recipients: email,
              name: '',
              format: 'HTML',
              frequency: 'once',
              customText: '',
              scheduleDays: [1,2,3,4,5],
              scheduleStartTime: '00:00',
              scheduleEndTime: '23:59',
              timeZone: moment.tz.guess(),
              timeZoneAbr: moment().tz(moment.tz.guess()).zoneAbbr(),
            });
            break;
          case 'WEBHOOK':
            notifications.splice(index+1, 0, { // todo refactor
              uid: UtilsService.generateID(),
              enabled: true,
              action: type,
              recipients: '',
              name: '',
              format: 'HTML - Custom',
              frequency: 'once',
              customText: '',
              scheduleDays: [1,2,3,4,5],
              scheduleStartTime: '00:00',
              scheduleEndTime: '23:59',
              timeZone: moment.tz.guess(),
              timeZoneAbr: moment().tz(moment.tz.guess()).zoneAbbr(),
            });
            break;
        }
      },

      onDeleteNotification: function(notifications, index) {
        let self = this;

        self.$refs.confirmDelete.open('Delete', `Are you sure you want to delete Notification ${index+1} of ${notifications.length}?`, { color: 'var(--bad-color)' }).then((confirm) => {
          if (confirm) {
            notifications.splice(index, 1);
          }
        });

      },

      onAddTrigger: function(trigger, index) {
        let self = this;
        if (self.triggers.length < 3) {
          let selectedStatus = 'ERROR';
          if (_.find(self.triggers, {selectedStatus:selectedStatus})) {
            selectedStatus = 'WARN';
            if (_.find(self.triggers, {selectedStatus:selectedStatus})) {
              selectedStatus = 'INFO';
            }
          }

          let newTrigger = {
            id: UtilsService.generateID(),
            selectedStatus: selectedStatus,
            threshold: '',
          };
          self.triggers.splice(index+1, 0, newTrigger);


          self.$nextTick(() =>  {
            let tTF = self.$refs['thresholdTextField-'+ newTrigger.id][0].$el.querySelector('input');
            tTF.focus({preventScroll:true});
            tTF.select();
          });

        }
      },

      onDeleteTrigger: function(trigger, index) {
        let self = this;
        if (self.triggers.length > 1) {
          trigger.threshold = '';
          self.handleThresholdChange(trigger);
          self.triggers.splice(index, 1);
        }
      },
      
      updateUniqueThresoldObjectModel: function () {
        let self = this;
        self.triggers[0].threshold = '0';
        self.handleThresholdChange(self.triggers[0]);

        for (const trigger of self.triggers.splice(1, self.triggers.length - 1)) {
          trigger.threshold = '';
          self.handleThresholdChange(trigger);
        }
        if (self.operation !== 'eq') {
          self.operation = 'gt';
        }
      }
    },
    props: {
      id: {
        type: String,
        default: 'new'
      },
      category: {
        type: String,
        default: ''
      },
      metric: {
        type: String,
        default: ''
      },
      groupBy: {
        type: Array,
        default: () => []
      },
      filter: {
        type: Object,
        default: undefined
      },
      next: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      mode: {
        type: String,
        default: ''
      },
      ts: {
        type: Number,
        default: 0
      },
      type: {
        type: String,
        default: 'metric'
      },
      group: {
        type: Array,
        default: () => [],
      }
    },
    watch: {
      id: function(newVal, oldVal) {
        this.currentId = newVal;
      },
      'conditionsAndNotificationItems.critical.threshold': function(newValue, oldValue) {
        let self = this;
        if ((oldValue === null || oldValue === '')
            && (newValue !== null && newValue !== '')
            && (!_.values(self.conditionsAndNotificationItems)[self.notificationTab].threshold)) {
          self.notificationTab = 0;
        } else if ((newValue === null || newValue === '') && self.notificationTab === 0 ) {
          if (_.values(self.conditionsAndNotificationItems)[1].threshold) {
            self.notificationTab = 1;
          } else if (_.values(self.conditionsAndNotificationItems)[2].threshold) {
            self.notificationTab = 2;
          }
        }
      },
      'conditionsAndNotificationItems.warn.threshold': function(newValue, oldValue) {
        let self = this;
        if ((oldValue === null || oldValue === '')
            && (newValue !== null && newValue !== '')
            && (!_.values(self.conditionsAndNotificationItems)[self.notificationTab].threshold)) {
          self.notificationTab = 1;
        } else if ((newValue === null || newValue === '') && self.notificationTab === 1 ) {
          if (_.values(self.conditionsAndNotificationItems)[0].threshold) {
            self.notificationTab = 0;
          } else if (_.values(self.conditionsAndNotificationItems)[2].threshold) {
            self.notificationTab = 2;
          }
        }
      },
      'conditionsAndNotificationItems.info.threshold': function(newValue, oldValue) {
        let self = this;
        if ((oldValue === null || oldValue === '')
            && (newValue !== null && newValue !== '')
            && (!_.values(self.conditionsAndNotificationItems)[self.notificationTab].threshold)) {
          self.notificationTab = 2;
        } else if ((newValue === null || newValue === '') && self.notificationTab === 2  ) {
          if (_.values(self.conditionsAndNotificationItems)[0].threshold) {
            self.notificationTab = 0;
          } else if (_.values(self.conditionsAndNotificationItems)[1].threshold) {
            self.notificationTab = 1;
          }
        }
      },
      operations: function(newValue, oldValue) {
        let self = this;
        if (self.operation) {
          if (!_.find(newValue, {value: self.operation})) {
            self.operation = newValue[0].value;
          }
        }
      },
      uniqueThreshold: function(newValue, oldValue) {
        let self = this;
        if ((!self.loading || self.isNew) && newValue) {
          self.updateUniqueThresoldObjectModel();
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .alertDetails {
    background-color: unset!important;
    
    
    .preselection-message {
      background-color: var(--panel-background);
      > .v-card__subtitle {
        color: var(--text-color);
      }
    }
    .table-header-row {
      margin-top: 10px;
    }
    .table-row {
      align-items: center;  
    }
    
    .table-cell-0 {
      flex-grow: 0;
      flex-shrink: 0;
    }
    
    .table-cell-1 {
      flex-grow: 1;
      flex-shrink: 1;
    }
    
    hr {
      margin-bottom: 0;
    }

    .second-row {
      margin-top: 12px;
    }

    .selected-day {
      color: var(--hover-color);
      font-family: var(--font-family);
      font-weight: 900;
      text-decoration: underline;
    }

    .status-text {
      text-transform: uppercase;  
    }
    
    .regular-text {
      color: var(--text-color);
    }
    
    .ad-status-icon {
      margin-right: 5px;
    }

    table td:last-child {
      width: 100%;
    }

    .alert-layout {
      margin-left: 25px;
      border-radius: var(--border-radius);
    }

    .edit-instructions-svg {
      margin-left: 25px;
      margin-right: 11px;
    }

    .edit-instructions-circle {
      fill: var(--primary-btn-bg-color);
    }

    .edit-instructions-text {
      fill: var(--primary-btn-color);
      font-size: 16px;
      font-weight: 900;
      text-anchor: middle;
    }

    .status-table-header {
      align-items: center;
    }
    
    .instructions-section-header-row {
    }
    
    .section-header-icon {
      margin-right: 5px;
      font-size: 16px;
      color: var(--text-color);
    }
    .instructions-section-header-text {
      margin-right: 5px;
      font-size: 16px;
      font-weight: bold;
      display: inline-block;
    }

    .instructions-section-subheader-text {
      margin-top: 12px;
      margin-right: 5px;
      font-size: 16px;
      display: inline-block;
    }

    .instructions-section-header-text-hint {
      margin-top: 4px;
      margin-left: 5px;
      font-size: 12px;
      font-weight: normal;
      font-style: italic;
      display: inline-block;
    }

    .instructions-section-header-text-embed {
    }

    .small-text-field {
      max-width: 45px;
    }

    .time-picker-field {
      max-width: 61px;
    }

    .time-picker-field.v-text-field > .v-input__control > .v-input__slot {
      cursor: unset;
    }

    .time-picker-menu-item {
      background-color: #FFFFFF;
      padding: 10px;
    }

    .small-text-field ::v-deep input {
      text-align: center
    }

    .day-selector {
      width: 100%;

      .v-btn:before {
        background-color:  var(--tmp-default-color);
      }

      &.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
        border-color: #00000061!important;
      }

      .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined),
      .v-btn-toggle > .v-btn.v-btn {
        color: var(--filter-text-color);
        background-color: var(--panel-background);
        opacity: 1;
      }
      
      .v-btn--active .v-btn__content {
        color: var(--primary-foreground-default);
      }

      .v-btn:not(.v-btn--round).v-size--small {
        min-width: 16px;
        max-width: 37px;
        width: calc(100%/7);
        height: 40px;
      }

      .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
        color: #FFFFFF;
        opacity: 1;
      }
    }

    .v-btn-toggle.day-selector>.v-btn.v-btn {
      padding: 0 6px;
    }

    .email-body {
      line-height: unset;
    }

    .condition-tab {
      font-weight: bold;
      min-width: 145px;
      letter-spacing: unset;

      .v-input--selection-controls {
        margin-top: 0;
      }
    }

    .column-center {
      justify-content: center;
    }

    i.notification-tool-btn {
      color: var(--filter-text-color)!important;
    }

    .notifications-container {
      background-color: var(--panel-background);
      
      &.tab-container {
        padding: 20px;
      }

      .add-notification-btn-text {
        font-weight: normal;
        font-size: 18px;
        line-height: 24px;
        font-family: var(--font-family);
        color: var(--filter-text-color);
        margin-left: 1px;
      }

      .add-notification-text {
        font-size: 16px;
        line-height: 18px;
        color: var(--text-color)
      }
      
      .notificationSelection {
        .v-tab {
          text-transform: unset;
        }

      }

      .notificationSelectionTab {
        .notificationHeader {
          border-bottom: 1px solid rgb(109, 120, 126);
        }
        &:not(:first-child) {
          margin-top: 25px;
        }
        .articleLink {
          color: var(--foreground-default);
        }
        .container .vy-row.notificationSelectionTabView .col {
          .vy-row {
            margin-left: 0px;
          }
          .vy-row:not(:first-child) {
            margin-top: 13px;
          }
          .vy-row:first-child {
            margin-top: 6px;
          }
          .vy-row:last-child {
            margin-bottom: 12px;
          }

        }
        .container .vy-row.notificationSelectionTabEdit {
          > .col > .vy-row {
            margin-left: 0;
            margin-right: 0;
          }
          > .col:first-child > .vy-row {
            margin-left: 5px;
          }
          > .col:last-child > .vy-row {
            margin-right: 5px;
          }
          > .col.note-first-col > .vy-row:nth-child(odd) {
            margin-top: 12px;
          }
          > .col.note-first-col > .vy-row:nth-child(even) {
            margin-bottom: 13px;
          }
          > .col.note-last-col > .vy-row:first-child ,
          > .col.note-last-col > .vy-row:last-child {
            margin-top: 12px;
            margin-bottom: 13px;
          }
          > .col.note-last-col > .vy-row:not(:first-child):not(:last-child):nth-child(even) {
            margin-top: 12px;
          }
          > .col.note-last-col > .vy-row:not(:first-child):not(:last-child):nth-child(odd) {
            margin-bottom: 13px;
          }
          > .col.note-last-col > .vy-row > .col:nth-child(odd) > .vy-row {
            margin-right: 0;
          }
          > .col.note-last-col > .vy-row > .col:nth-child(even) > .vy-row {
            margin-left: 0;
          }
          &.data  {
            margin-top: 20px;
          }
        }

        .templateButtons {
          margin-left: auto;
          margin-right: 5px;
          color:  var(--default-color);
          font-size: 14px;
          .insertLabel {
            color:  var(--text-color);
            font-weight: bold;
          }
          .sample {
            cursor: pointer;
            .logo {
              margin-left: 10px;
              margin-right: 2px;
              height: 16px;
              width: 16px;
            }
            &:hover {
              text-decoration: underline;
            }
          }
        }

        .time-to {
          margin: 0 5px;
          align-self: center;
        }
      }
    }

    .trigger-action-toolbar-icon {
      margin-top: 6px;
      margin-bottom: 10px;
      vertical-align: middle;

      font-size: 24px;
      line-height: 24px;
      //margin-left: 16px;
      color: var(--text-color);
      &:hover {
        color:  var(--tmp-default-color);
      //  font-weight: bold;
      }
    }
    
    .trigger-action-toolbar-icon-disabled {
      margin-top: 6px;
      margin-bottom: 10px;
      vertical-align: middle;

      font-size: 24px;
      line-height: 24px;
      //margin-left: 16px;
      color: var(--text-color);
      opacity: 0.25;
    }
    
    .notification-action-toolbar-icon {
      font-size: 20px;
      line-height: 24px;
      margin-left: 16px;
      color: var(--text-color);
      &:hover {
        font-weight: bold;
      }
    }
    .notification-action-toolbar-btn {
      cursor: pointer;
    }


    .notification-title {
      font-size: 14px;
      font-weight: bold;
      line-height: 15px;
      margin-left: 7px;
    }
    .notification-webhook-help {
      font-size: 14px;
      line-height: 15px;
      margin-left: 20px;
      margin-right: 20px;
      a {
        text-decoration: underline;
        color: inherit;
      }
    }
    .notification-title-icon {
      margin-left: 6px;
    }
    .notification-title .v-toolbar__title {
      font-size: 14px;
      font-weight: bold;
      line-height: 15px;
    }


    i.notification-title {
      margin-left: 7px;
    }

    .condition-critical {
      color: var(--bad-color)!important;
    }

    .condition-warn {
      color: var(--fair-color)!important;
    }

    .condition-info {
      color: var(--neutral-color)!important;
    }
    
    .group-info {
      font-style: italic;
      white-space: nowrap;
    }

    .minutes-input { // not specific enough so added the internal
      &.small-text-field.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) {
        background-color: var(--panel-background);
        color: var(--text-color);
      }
      ::v-deep input {
        color: var(--disabled-color);
      }
    }
    .threshold-field-critical {
      color: var(--bad-color)!important;
      background-color: rgba(from var(--bad-color) r g b / 0.15)!important;
      border-color: rgba(from var(--bad-color) r g b / 0.25)!important;
    }

    .threshold-field-warn {
      color: var(--fair-color)!important;
      background-color: rgba(from var(--fair-color) r g b / 0.15)!important;
      border-color: rgba(from var(--fair-color) r g b / 0.25)!important;
    }

    .threshold-field-info {
      color: var(--neutral-color)!important;
      background-color: rgba(from var(--neutral-color) r g b / 0.15)!important;
      border-color: rgba(from var(--neutral-color) r g b / 0.25)!important;
    }

    .theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn--disabled.action-group-btn .v-icon {
      color: var(--disabled-color) !important; // vuetify uses important so we have to
    }
    .theme--light.v-select .v-select__selections {
      color: var(--disabled-color);
    }

    .notification-tabs {
      max-height:40px;

      ::v-deep .v-item-group {
        max-height:40px;
      }
      ::v-deep .v-tabs-slider,
      ::v-deep .v-item-group {
        color: inherit!important;
      }
    }

    .notification-tabs.v-tabs--align-with-title > .v-tabs-bar:not(.v-tabs-bar--show-arrows):not(.v-slide-group--is-overflowing) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tab:first-child,
    .notification-tabs.v-tabs--align-with-title > .v-tabs-bar:not(.v-tabs-bar--show-arrows):not(.v-slide-group--is-overflowing) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tabs-slider-wrapper + .v-tab {
      margin-left:26px;
    }

    .v-btn-toggle {
      border-radius: var(--border-radius);
    }

    .v-btn-toggle>.v-btn.v-btn.action-group-btn:last-child{
      border-top-right-radius: var(--border-radius);
      border-bottom-right-radius: var(--border-radius);
    }

    .v-btn-toggle>.v-btn.v-btn.action-group-btn:first-child {
      border-top-left-radius: var(--border-radius);
      border-bottom-left-radius: var(--border-radius);
      border-left-width: 1px;
    }

    .v-btn-toggle>.v-btn.v-btn.action-group-btn {
      border-left-width: 0;
    }

    .theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn--has-bg.action-group-btn.save-btn {
      background-color: var(--primary-btn-bg-color);
      .v-icon {
        color: var(--primary-btn-color)!important; // hack
      }
    }

    .v-btn-toggle > .v-btn.v-btn.action-group-btn {
      opacity: 1;
      padding: 0 7px;
    }

    .v-btn.action-group-btn:not(.v-btn--round).v-size--default{
      height: 40px;
    }

    .v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.action-group-btn.v-size--default {
      height: 40px;
      min-width: 50px;
    }

    .action-toolbar {
      margin-top: 15px;
      margin-bottom: 17px;
    }

    .action-switch {
      margin: 0px 0px;
    }
    .legend-switch.action-switch {
      transform: unset;
    }

    .metricSelection {
      .container .vy-row .col.metricSelectionView .vy-row:not(:first-child) {
        margin-top: 22px;
      }
      .container .vy-row .col.metricSelectionEdit .vy-row .col:not(:first-child) .vy-row {
        margin-left: -3px;
      }
      .container .vy-row .col.metricSelectionEdit .vy-row .col:not(:last-child) .vy-row {
        margin-right: -3px;
      }

      .before-devices-label {
        margin-top: 25px;
      }
      .before-filter-switch {
        margin-top: 13px;
      }

      .vyopta-filter-expression {
        margin-left: 0px;
      }
      .for-these-row {
        margin-left: -9px;
      }
    }
    
    .eventSelection, .eventSourceSelection {
      // todo

      .vyopta-filter-expression {
        margin-left: 0px;
      }

      .for-these-row {
        margin-left: -9px;
      }

      .event-filter-title {
        font-weight: 700;
        color: var(--neutral2-color); // was #6F787D; 4.17:1 on white
        margin-bottom: 8px;
        text-transform: uppercase;
      }

    }

    .thresholdSelection {
      .trigger-sentence-row {
        align-items: baseline;
        &:not(:first-of-type) {
          margin-top: 20px;
        }
      }
      
      .container .vy-row .col .vy-row .col:first-child .vy-row {
        margin-right: -8px;
        margin-left: -15px;
      }
      .container .vy-row .col .vy-row .col:nth-child(2) .vy-row {
        margin-left: -8px;
      }
      .container .vy-row .col .vy-row .col .vy-row .col .vy-row .col {
        padding-left: 8px!important;
        &.threshold-label-center {
          padding-right: 8px!important;
        }
      }

      .threshold-extra-space {
        margin-right: 1px;
      }

      .v-btn-toggle {
        border-radius: var(--border-radius);
      }

      .v-btn-toggle>.v-btn.v-btn.selection-button:last-child{
        border-top-right-radius: var(--border-radius);
        border-bottom-right-radius: var(--border-radius);
      }

      .v-btn-toggle>.v-btn.v-btn.selection-button:first-child {
        border-top-left-radius: var(--border-radius);
        border-bottom-left-radius: var(--border-radius);
        border-left-width: 1px;
      }

      .v-btn-toggle>.v-btn.v-btn.selection-button {
        border-left-width: 0;
      }

      .v-btn-toggle > .v-btn.v-btn.selection-button {
        opacity: 1;
        padding: 0 7px;
      }

      .v-btn:not(.v-btn--round).v-size--default{
        height: 40px;
      }

      .v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
        height: 40px;
        min-width: 50px;
      }

      .v-btn.selection-button:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
        opacity: 0.05;
      }
      .v-btn.selection-button.threshold-selection-button:not(.v-btn--text):not(.v-btn--outlined):before {
        opacity: 0;
      }
      .v-btn.selection-button.threshold-selection-button:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
        opacity: 0;
      }

      .v-btn.selection-button:not(.v-btn--text):not(.v-btn--outlined).v-btn--active span {
        opacity: 0.3;
      }

      .v-btn.selection-button.threshold-selection-button:not(.v-btn--text):not(.v-btn--outlined) span {
        opacity: 0.3;
      }
      .v-btn.selection-button.threshold-selection-button:not(.v-btn--text):not(.v-btn--outlined).v-btn--active span {
        opacity: 1;
      }

      .v-btn.selection-button:not(.v-btn--text):not(.v-btn--outlined):hover:before {
        opacity: 0.15;
      }


      .theme--light.v-btn.selection-button:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
        background-color: var(--filter-bg-color);
        &.threshold-selection-button {
          background-color: #F7F7F7;
        }

      }

      .theme--light.v-btn.selection-button:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).v-btn--active {
        background-color: #F7F7F7;
        &.threshold-selection-button {
          background-color: var(--filter-bg-color);
        }
      }
    }

    .info-btn {
      font-size: 9px;
      line-height: 9px;
      vertical-align: super;
    }

    .quality-tt-body {
      font-size: 10px;
      line-height: 10px;
      font-family: var(--font-family);
      font-weight: 500;
    }

    .quality-tt-header {
      font-size: 10px;
      line-height: 10px;
      font-family: var(--font-family);
      font-weight: 800;
    }

    .quality-tt {
      text-align-last: center;
    }

    .groupby-tt-body {
      font-size: 13px;
      line-height: 15px;
      font-family: var(--font-family);
      font-weight: 500;
    }

    .groupby-tt-header {
      font-size: 13px;
      line-height: 15px;
      font-family: var(--font-family);
      font-weight: 800;
    }



  }
  .new-beta.badge {
    width: 41px;
    height: 16px;
    background-color: var(--active-background);
    line-height: 9px;
    color: var(--tooltip-color);
    font-style: italic;
    border-radius: 4px;
    text-align: center;
    font-weight: 700;
    font-size: 11px;
  }
</style>
<style lang="scss">
  .alertDetails .addNotificationMenuContent {
    width: 225px;
    .v-list {
      padding-top: 6px;
      padding-bottom: 6px;
      .v-list-item {
        cursor: pointer;

        span {
          margin-left: 10px;
        }
      }
      .v-divider {
        margin-top: 6px;
        margin-bottom: 6px;
      }
    }
  }

  .alertDetails .insertMenuContent {
    //width: 225px;
    .v-list {
      padding-top: 6px;
      padding-bottom: 6px;
      .v-list-item {
        cursor: pointer;
        &:hover {
          background-color: var(--hover-background);
        }

        span {
          color: var(--text-color);
          margin-left: 10px;
        }
      }
      .v-divider {
        margin-top: 6px;
        margin-bottom: 6px;
      }
    }
  }

  .v-application--is-ltr .alertDetails .group-by-menu-content .v-list-item__action:first-child {
  }

  .alertDetails .group-by-menu-content {
    .v-list-item__action {
      margin: 4px 10px 4px 0;
    }
    .v-input--selection-controls__ripple {
      margin: 0;
    }

    //width: 225px;
    .v-list {
      padding-top: 6px;
      padding-bottom: 6px;
      .v-list-item {
        cursor: pointer;
        &:hover {
          background-color: var(--hover-background);
        }

        span {
          color: var(--text-color);
          margin-left: 10px;
        }
      }
      .v-divider {
        margin-top: 6px;
        margin-bottom: 6px;
      }
    }
  }

  @media (max-height: 490px) {
    .wrapper {
      .alertDetails {
        .selection-table-modal > .modal-wrapper > .modal-container {
          > .modal-body {
            overflow: auto!important;
          }
        }
      }
    }
  }

  .wrapper {
    .alertDetails {
      // fix for https://github.com/vuetifyjs/vuetify/issues/6275
      .select-field.v-select.v-input--is-dirty input {
        display: none;
      }
      .v-select__selection {
        max-width: none;
      }

      .select-field.v-select.v-input--dense .v-select__selection--comma {
        margin: 4px 0 4px 0;
        color: var(--text-color);
      }



      .selection-table-modal > .modal-wrapper > .modal-container {
        width: 1250px;
        max-width: 90vw;
  
        max-height: calc(100vh - 150px);
        padding: 0;

        > .modal-body {
          margin: 0;
          border: none;
          overflow: hidden;
  
          .data-selection-table {
            padding: 0 10px;

            a:hover {
              text-decoration: underline;
            }
  
            .tabulator {
              height: calc(100vh - 150px - 204px - var(--filter-height));
              min-height: 150px;
              margin-bottom: 0;
            }
  
            .selections-container {
              height: calc(100vh - 150px - 204px  - var(--filter-height) - 50px);
              min-height: calc(150px - 36px);
              font-size: 12px;
            }
  
            .table-list-wrapper .list-container {
              padding: 0;
              max-width: unset;
            }
          }
  
        }
      }
      .selection-table-modal .autocomplete-result-list {
        padding-left: 0;
      }
    }
  }

  .content.alert-main-view {
    padding: 0 32px 20px 32px;
  }

  .alertMainPanel {
    background-color: var(--panel-background);
    color: var(--text-color);
    border-radius: var(--border-radius);
  }

  .select-field-highlight {
    font-weight: 500;
  }

  // Vuetify overrides
  
  .theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn.action-group-btn .v-icon,
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled),
  .theme--light.v-subheader {
    color: var(--text-color);
  }
  .theme--light.v-input--is-disabled input::placeholder {
    color: var(--disabled-color);
  }

  .select-field .v-icon {
    font-size: 16px;
  }

  .select-field .v-select__selections {
    color: var(--text-color);
    font-size: 14px;
  }

  .select-field .v-text-field--enclosed .v-input__append-inner {
    margin-top: 10px;
  }

  .v-application#alert-details-app .threshold-field.error--text {
    color: #c07728 !important;
  }

  .small-text-field.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding: 0 2px;
  }

  .title-text-row .header-title.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding: 0;
  }

  .title-text-row .header-title.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding: 0;
  }

  .v-application#alert-details-app .title-text-row .header-title.theme--light.v-input input {
    font-size: 20px;
    margin-top: -5px; // todo
    margin-bottom: 0; // todo
    font-weight: 400;
    letter-spacing: unset;
  }

  .v-application#alert-details-app .title-text-row .header-title.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
    padding: 0;
  }

  .title-text-row .header-title.v-text-field > .v-input__control > .v-input__slot:before {
    border-style: unset;
  }

  .v-subheader {
    font-weight: 600;
  }

  .v-list--dense .v-subheader{
    font-size: 14px;
  }

  .alertDetails .v-menu__content:not(.addNotificationMenuContent):not(.insertMenuContent) .v-list {
    padding: 0;
  }

  .v-menu__content {
    box-shadow: none;
    border: 1px solid #bfbfbf;
    margin-top: 0;
  }

  .v-select .submetric {
    font-weight: 400;
  }

  .submetric {
    font-weight: 500;
  }

  .substatus {
    font-weight: 700;
  }

  .v-list-item--disabled .substatus {
    opacity: 0.25;
  }

  .item-container {
    padding: 0;
  }

  .selection-container {
    padding: 0;
  }
  
  //ensure the threshold lines line up
  .select-status .selection-container {
    min-width: 83px;
  }

  .deprecated {
    opacity: 0.4;
  }
  
  #vyopta-app .system-icon-col.col {
    padding: 0 2px;
  }

  #alert-details-app .v-application--wrap {
    min-height: unset;
  }

  #alert-details-app .container.alert-header {
    padding: 5px 76px 0 15px;
    margin-left: 32px;
    margin-right: 12px; 
  }

  .title-text-row .header-title {
    font-size: 20px;
    margin-top: 5px;
    margin-bottom: 8px;
    .v-input__control {
      margin-top: -2.5px;
      margin-bottom: -8px;
    }
    font-weight: 400;
    letter-spacing: unset;
  }

  .title-breadcrumb-row {
    padding-top: 1px;
  }
  
  .title-text-row {
    flex-wrap: nowrap;
    align-items: center;
  }

  .title-row {
    margin-bottom: 3px;
    margin-top: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100vw - 575px); // todo handle nav drawer mini size
    min-width: 400px;
  }

  .title-breadcrumb {
    font-size: 12px;
    margin-bottom: -5px;
  }

  .title-breadcrumb-divider {
    margin: 0 6px;
  }

  #alert-details-app .container {
    margin-left: unset;
    margin-right: unset;
  }

  .field-label {
    font-size: 14px;
    font-weight: 600;
    color: var(--filter-text-color);
    white-space: nowrap;
  }

  .field-label-center {
    width: 100%;
    text-align: center;
    line-height: 13px;
    margin-top: 2px;
  }

  .field-inline-label {
    line-height: 40px;
    white-space:nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .field-inline-highlight {
    font-weight: 600;
  }

  .condition-span {
    margin-right: 15px;
  }

  #alert-details-app section {
    min-width: 0;
  }

  #alert-details-app .autocomplete-result-list {
    padding-left: 0;
  }

  .status-chip {
    margin-right: 16px;
    margin-left: 0;
    white-space: nowrap;
  }

  .v-application#alert-details-app .day-selector.v-btn-toggle>.v-btn.v-btn {
    border-radius: 0;
  }

  .v-application#alert-details-app .day-selector.v-btn-toggle>.v-btn.v-btn:last-child{
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }

  .v-application#alert-details-app .day-selector.v-btn-toggle>.v-btn.v-btn:first-child {
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
  }

  .v-application#alert-details-app .v-btn-toggle>.v-btn.v-btn.action-group-btn {
    border-radius: 0;
  }

  .v-application#alert-details-app .v-btn-toggle>.v-btn.v-btn.action-group-btn:last-child{
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }

  .v-application#alert-details-app .v-btn-toggle>.v-btn.v-btn.action-group-btn:first-child {
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
  }

  .v-application#alert-details-app .v-btn.selection-button:not(.v-btn--flat):not(.v-btn--outlined):not(.v-btn--disabled) .v-btn.only-btn .v-btn__content,
  .v-application#alert-details-app .v-btn.selection-button .v-btn.only-btn .v-btn__content {
    font-size: 8px;
    line-height: 10px;
    font-weight: 700;
    font-family: var(--font-family);
    letter-spacing: unset;
    text-transform: uppercase;
    color: #ffffff;
  }

  .v-application#alert-details-app .v-btn.selection-button:not(.v-btn--flat):not(.v-btn--outlined):not(.v-btn--disabled) .v-btn.only-btn.label-btn .v-btn__content,
  .v-application#alert-details-app .v-btn.selection-button .v-btn.only-btn.label-btn .v-btn__content {
    color: var(--neutral2-color); // was #6D787E; 4.63:1 on white
  }


  .v-application#alert-details-app .v-btn-toggle>.v-btn.v-btn.selection-button {
    border-radius: 0;
  }

  .v-application#alert-details-app .v-btn-toggle>.v-btn.v-btn.selection-button:last-child{
    border-top-right-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
  }

  .v-application#alert-details-app .v-btn-toggle>.v-btn.v-btn.selection-button:first-child {
    border-top-left-radius: var(--border-radius);
    border-bottom-left-radius: var(--border-radius);
  }

  .v-application#alert-details-app .v-btn.selection-button:not(.v-btn--flat):not(.v-btn--outlined):not(.v-btn--disabled) .v-btn__content {
    flex-wrap: wrap;
  }

  .v-application#alert-details-app .v-btn.selection-button .v-btn__content {
    font-size: 14px;
    font-weight: 500;
    font-family: var(--font-family);
    letter-spacing: -0.01em;
  }

  .my-tab-fade-transition-enter-active, .my-tab-fade-transition-leave-active {
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
  }
  .my-tab-fade-transition-move {
    transition: transform 0.3s;
  }
  .my-tab-fade-transition-enter, .my-tab-fade-transition-leave-to {
    opacity: 0 !important;
  }

  .v-application#alert-details-app .threshold-field.theme--light.v-input:not(.v-input--is-disabled) input {
    color:inherit;
  }

  .thresholdSelection .v-text-field--outlined.v-input--is-disabled fieldset {
    border-color: var(--panel-background);
  }
  
  .threshold-field-critical,
  .threshold-field-critical.threshold-field.v-text-field--outlined:not(.error--text) fieldset{
    color: var(--bad-color);
    border-color: rgba(from var(--bad-color) r g b / 0.25);
  }

  .threshold-field-warn,
  .threshold-field-warn.threshold-field.v-text-field--outlined:not(.error--text) fieldset {
    color: var(--fair-color);
    border-color: rgba(from var(--fair-color) r g b / 0.25);
  }

  .threshold-field-info,
  .threshold-field-info.threshold-field.v-text-field--outlined:not(.error--text) fieldset{
    color: var(--neutral-color);
    border-color: rgba(from var(--neutral-color) r g b / 0.25);
  }

  .threshold-field-critical input:-webkit-autofill   {
    -webkit-box-shadow: 0 0 0 1000px #f4cfcc inset;
  }

  .threshold-field-warn input:-webkit-autofill   {
    -webkit-box-shadow: 0 0 0 1000px #f8e2c8 inset;
  }

  .threshold-field-info input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #d8dadc inset;
  }

  .v-textarea.data-body {
    line-height: unset;
    font-family: "Lucida Console", "Monaco", monospace;
    font-size: 14px;
    textarea {
      line-height: 18px;
    }
  }

  .data-body .v-btn--fab.v-btn--absolute.v-btn--right {
    right: 4px
  }

  .data-body .v-btn--fab.v-btn--absolute.v-btn--top {
    top: 4px
  }

  .data-body-readonly {
    &.v-text-field--outlined {
      fieldset {
        border: unset;
      }
    }
    &.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
      padding: 0;
    }
  }


  .v-application#alert-details-app .v-tooltip__content:not(.single-filter-quick-pick-tt) {
    padding: 10px 15px;
    font-weight: bold;
    letter-spacing: unset;
    font-size: 12px;
    line-height: 9px;
    font-family: var(--font-family);
    border-radius: 3px;
  }

  .v-application#alert-details-app .v-tooltip__content.above:not(.single-filter-quick-pick-tt) {
    padding: 10px 10px;
    pointer-events: auto;
  }

  .v-application#alert-details-app :not(.single-filter-quick-pick-tt).v-tooltip__content:not(.single-filter-quick-pick-tt):not(.above):after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 8px 8px;
    border-top-color: inherit;
    border-bottom-color: inherit;
    border-left-color: transparent;
    border-right-color: transparent;
    display: block;
    width: 0;
    z-index: 1;
    top: -8px;
    left: 50%;
    transform: translate(-50%, 0px);
  }

  .v-application#alert-details-app .quality-tt-link a {
    font-size: 10px;
    line-height: 9px;
    font-family: var(--font-family);
    font-weight: 500;
    text-decoration: underline;
    color: #ffffff;

    &:hover {
      color: #000000;
    }
  }

  .v-application#alert-details-app .v-tooltip__content.above:not(.single-filter-quick-pick-tt):after {
    content: "";
    position: absolute;
    border-style: solid;
    border-width: 8px 8px 0 8px;
    border-top-color: inherit;
    border-bottom-color: inherit;
    border-left-color: transparent;
    border-right-color: transparent;
    display: block;
    width: 0;
    z-index: 1;
    bottom: 2px;
    left: 50%;
    transform: translate(-50%, 0px);
  }

  .v-application#alert-details-app .quality-tt-link a {
    font-size: 10px;
    line-height: 9px;
    font-family: var(--font-family);
    font-weight: 500;
    text-decoration: underline;
    color: #ffffff;

    &:hover {
      color: #000000;
    }
  }

  .v-application#alert-details-app .v-tooltip__content.above:not(.single-filter-quick-pick-tt):after {
    content: "";
    position: absolute;
    border-style: solid;
    border-width: 8px 8px 0 8px;
    border-top-color: inherit;
    border-bottom-color: inherit;
    border-left-color: transparent;
    border-right-color: transparent;
    display: block;
    width: 0;
    z-index: 1;
    bottom: 2px;
    left: 50%;
    transform: translate(-50%, 0px);
  }


  .v-application#alert-details-app .day-selector {
    .v-btn .v-btn__content {
      font-family: var(--font-family);
      font-weight: bold;
      font-size: 14px;
    }

    .v-btn:not(.v-btn--flat):not(.v-btn--outlined):not(.v-btn--disabled):not(.v-btn--active) .v-btn__content {
      color: var(--filter-text-color);
    }
  }

  #vyopta-app {
    .vy-row.notificationSelectionTabEdit:not(.no-gutters) {
      // Hacky fix on top of hacky fix for vuetify overrides to trim just a hair off padding
      .col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1,
      .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1,
      .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1,
      .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1,
      .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
        padding: 0 12px;
      }
    }
    
    #alert-details-app .v-select.v-input .v-icon {
      font-size: 15px;
      color: var(--text-color);
    }
  }
  
  @media (min-width: 1194px) {
    .col-lg {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    }

    .col-lg-auto {
      flex: 0 0 auto;
      width: auto;
      max-width: 100%;
    }

    .col-lg-1 {
      flex: 0 0 8.3333333333%;
      max-width: 8.3333333333%;
    }

    .col-lg-2 {
      flex: 0 0 16.6666666667%;
      max-width: 16.6666666667%;
    }

    .col-lg-3 {
      flex: 0 0 25%;
      max-width: 25%;
    }

    .col-lg-4 {
      flex: 0 0 33.3333333333%;
      max-width: 33.3333333333%;
    }

    .col-lg-5 {
      flex: 0 0 41.6666666667%;
      max-width: 41.6666666667%;
    }

    .col-lg-6 {
      flex: 0 0 50%;
      max-width: 50%;
    }

    .col-lg-7 {
      flex: 0 0 58.3333333333%;
      max-width: 58.3333333333%;
    }

    .col-lg-8 {
      flex: 0 0 66.6666666667%;
      max-width: 66.6666666667%;
    }

    .col-lg-9 {
      flex: 0 0 75%;
      max-width: 75%;
    }

    .col-lg-10 {
      flex: 0 0 83.3333333333%;
      max-width: 83.3333333333%;
    }

    .col-lg-11 {
      flex: 0 0 91.6666666667%;
      max-width: 91.6666666667%;
    }

    .col-lg-12 {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .v-application--is-ltr .offset-lg-0 {
      margin-left: 0;
    }
    .v-application--is-rtl .offset-lg-0 {
      margin-right: 0;
    }

    .v-application--is-ltr .offset-lg-1 {
      margin-left: 8.3333333333%;
    }
    .v-application--is-rtl .offset-lg-1 {
      margin-right: 8.3333333333%;
    }

    .v-application--is-ltr .offset-lg-2 {
      margin-left: 16.6666666667%;
    }
    .v-application--is-rtl .offset-lg-2 {
      margin-right: 16.6666666667%;
    }

    .v-application--is-ltr .offset-lg-3 {
      margin-left: 25%;
    }
    .v-application--is-rtl .offset-lg-3 {
      margin-right: 25%;
    }

    .v-application--is-ltr .offset-lg-4 {
      margin-left: 33.3333333333%;
    }
    .v-application--is-rtl .offset-lg-4 {
      margin-right: 33.3333333333%;
    }

    .v-application--is-ltr .offset-lg-5 {
      margin-left: 41.6666666667%;
    }
    .v-application--is-rtl .offset-lg-5 {
      margin-right: 41.6666666667%;
    }

    .v-application--is-ltr .offset-lg-6 {
      margin-left: 50%;
    }
    .v-application--is-rtl .offset-lg-6 {
      margin-right: 50%;
    }

    .v-application--is-ltr .offset-lg-7 {
      margin-left: 58.3333333333%;
    }
    .v-application--is-rtl .offset-lg-7 {
      margin-right: 58.3333333333%;
    }

    .v-application--is-ltr .offset-lg-8 {
      margin-left: 66.6666666667%;
    }
    .v-application--is-rtl .offset-lg-8 {
      margin-right: 66.6666666667%;
    }

    .v-application--is-ltr .offset-lg-9 {
      margin-left: 75%;
    }
    .v-application--is-rtl .offset-lg-9 {
      margin-right: 75%;
    }

    .v-application--is-ltr .offset-lg-10 {
      margin-left: 83.3333333333%;
    }
    .v-application--is-rtl .offset-lg-10 {
      margin-right: 83.3333333333%;
    }

    .v-application--is-ltr .offset-lg-11 {
      margin-left: 91.6666666667%;
    }
    .v-application--is-rtl .offset-lg-11 {
      margin-right: 91.6666666667%;
    }
  }


</style>
